var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/constants/privateProducts.js
var require_privateProducts = __commonJS({
  "src/constants/privateProducts.js"(exports, module) {
    "use strict";
    var allPrivateProductsIds2 = [
      17,
      // Bundle: Gelt + mStable + Aave v2
      43,
      // Liquid Collective
      63,
      // Sherlock
      65,
      // Stakewise 3rd party (3 ETH/validator)
      66,
      // Stakewise operated (3 ETH/validator)
      82,
      // EtherFi
      83,
      // Squeeth by Opyn (Sherlock)
      84,
      // Rage Trade (Sherlock)
      85,
      // Sentiment (Sherlock)
      86,
      // Lyra Newport (Sherlock)
      87,
      // Perennial (Sherlock)
      88,
      // LiquiFi (Sherlock)
      89,
      // Lyra Avalon (Sherlock)
      90,
      // Buffer Finance (Sherlock)
      91,
      // Hook (Sherlock)
      92,
      // Holyheld (Sherlock)
      93,
      // Union Finance (Sherlock)"
      94,
      // OpenQ (Sherlock)
      99,
      // Chorus One
      100,
      // Kiln
      101,
      // Vertex (Native Protocol)
      102,
      // The Retail Mutual
      104,
      // Teller (Sherlock)
      105,
      // Ajna (Sherlock)
      107,
      // Vox Finance (UnoRe)
      108,
      // MahaLend (UnoRe)
      109,
      // SELF (UnoRe)
      110,
      // Scallop (UnoRe)
      111,
      // WeFi (UnoRe)
      112,
      // ZkTsunami (UnoRe)
      113,
      // Hats Protocol
      151,
      // Arcadia (Sherlock)
      159,
      // Liquid Collective
      163,
      // Pocket Universe
      164,
      // Request Finance
      186,
      // Delta Prime (UnoRe)
      195,
      // Dialectic Moonphase
      196,
      // Dialectic Chronograph
      220,
      // Flat Money (Sherlock)
      227,
      // Base DeFi Pass
      233,
      // Relative Finance
      239,
      // Everstake
      240,
      // Ensuro
      250,
      // Fasanara
      259,
      // Bittensor
      260,
      // DeFi Covered
      273,
      // L1 Advisors Cover
      274,
      // Figment ETH Slashing
      291,
      // OC Cover
      292
      // Usual Bug Bounty
    ];
    module.exports = {
      allPrivateProductsIds: allPrivateProductsIds2
    };
  }
});

// src/index.ts
import * as deployments from "@nexusmutual/deployments";

// src/buyCover/index.ts
var buyCover_exports = {};
__export(buyCover_exports, {
  calculatePremiumWithCommissionAndSlippage: () => calculatePremiumWithCommissionAndSlippage
});

// node_modules/viem/_esm/constants/address.js
var zeroAddress = "0x0000000000000000000000000000000000000000";

// generated/types.ts
var types_exports = {};
__export(types_exports, {
  ProductTypes: () => ProductTypes,
  allLogoFileNames: () => allLogoFileNames,
  allLogoNames: () => allLogoNames
});
var allLogoFileNames = [
  "zerox.svg",
  "oneinch.svg",
  "aavev2.svg",
  "abracadabra.svg",
  "alchemix.svg",
  "anchor.svg",
  "angle.svg",
  "argent.svg",
  "aura.svg",
  "babylon.svg",
  "badgerdao.svg",
  "balancer.svg",
  "bancor.svg",
  "bancor.svg",
  "beefy.svg",
  "binance.svg",
  "blockFi.svg",
  "gelt.svg",
  "centrifuge.svg",
  "coinbase.svg",
  "compoundv2.svg",
  "convex.svg",
  "convex.svg",
  "convex.svg",
  "crypto-com.svg",
  "curve.svg",
  "curve.svg",
  "curve.svg",
  "dydx.svg",
  "ease.svg",
  "enzyme.svg",
  "enzyme.svg",
  "eth.svg",
  "euler.svg",
  "fodl.svg",
  "ftx.svg",
  "gearbox.svg",
  "gemini.svg",
  "gmx.svg",
  "goldfinch.svg",
  "hodlnaut.svg",
  "kraken.svg",
  "ledn.svg",
  "liquidcollective.svg",
  "liquity.svg",
  "sky-money.svg",
  "mstable.svg",
  "nested.svg",
  "nexo.svg",
  "notional-finance.svg",
  "olympusdao.svg",
  "opyn.png",
  "originusd.svg",
  "pangolin.svg",
  "perpetual.svg",
  "pooltogether.svg",
  "premia.svg",
  "rari.svg",
  "reflexer.png",
  "ribbon.svg",
  "gnosis-safe.svg",
  "tokensets.svg",
  "tokensets.svg",
  "sherlock.svg",
  "stakedao.svg",
  "stakewise.svg",
  "stakewise.svg",
  "sushiswap.svg",
  "synthetix.svg",
  "thorchain.svg",
  "lfj.jpg",
  "uniswapv2.svg",
  "uniswapv2.svg",
  "vector.svg",
  "vesper.svg",
  "yearn.svg",
  "yearn.svg",
  "yeti.png",
  "yield-app.svg",
  "alpaca.svg",
  "wefi.png",
  "exactly.svg",
  "etherfi.svg",
  "squeeth-by-opyn.png",
  "rage-trade.svg",
  "sentiment.png",
  "lyra.svg",
  "perennial.jpeg",
  "liquify.svg",
  "lyra.svg",
  "buffer-finance.svg",
  "hook.jpeg",
  "holyheld.jpeg",
  "union-finance.svg",
  "openq.png",
  "level-finance.png",
  "offramp.png",
  "aavev3.svg",
  "morpho.svg",
  "chorusone.svg",
  "kiln.svg",
  "vertex.svg",
  "the-retail-mutual.png",
  "figment.svg",
  "teller.svg",
  "ajna.svg",
  "eigenlayer.png",
  "vox.png",
  "mahalend.svg",
  "self.svg",
  "scallop.svg",
  "wefi.png",
  "zktsunami.svg",
  "hats.svg",
  "sdai.svg",
  "spark-lending.svg",
  "defi-edge.svg",
  "stakewisev3.svg",
  "compoundv3.svg",
  "deprecated.svg",
  "deprecated.svg",
  "deprecated.svg",
  "deprecated.svg",
  "yearn.svg",
  "velodrome.svg",
  "gmxv2.svg",
  "dhedge.svg",
  "term-finance.png",
  "pendle.svg",
  "aerodrome.svg",
  "hyperliquid.svg",
  "maverick.svg",
  "equilibria.svg",
  "camelot.svg",
  "nftperp.svg",
  "gearbox.svg",
  "pxeth.svg",
  "fx-protocol.svg",
  "prisma.svg",
  "beethovenx.svg",
  "arrakis.svg",
  "yearn-v3.svg",
  "synthetix-ecosystem.svg",
  "eigenlayer-etherfi-pendle.svg",
  "beefy-curve.svg",
  "beefy-compoundv3.svg",
  "beefy-balancerv2-aura.svg",
  "notional-finance.svg",
  "fraxlend.svg",
  "morpho.svg",
  "etherfi.svg",
  "arcadia.svg",
  "fx-protocol.svg",
  "eigenlayer-kelp-pendle.svg",
  "eigenlayer-renzo-pendle.svg",
  "eigenlayer-swell-pendle.svg",
  "arcadia.svg",
  "derive.svg",
  "renzo.png",
  "liquidcollective.svg",
  "etherfi-zircuit-pendle.svg",
  "kelpdao-zircuit-pendle.svg",
  "renzo-zircuit-pendle.svg",
  "pocket-universe.png",
  "request-finance.svg",
  "etherfi.svg",
  "superform.svg",
  "etherfi.svg",
  "beefy-uniswap.svg",
  "rockX.png",
  "sUSDe-pendle.svg",
  "sUSDe-karak-pendle.svg",
  "steakhouse-morpho.svg",
  "re7-morpho.svg",
  "index-coop.svg",
  "gauntlet-morpho.svg",
  "etherfi-karak-pendle.svg",
  "eigenlayer-puffer-pendle.svg",
  "eigenlayer-bedrock-pendle.svg",
  "crvUSD-silo-pendle.svg",
  "block-analitica-morpho.svg",
  "beefy-aerodrome.svg",
  "extrafi.svg",
  "moonwell.jpg",
  "instadapp-fluid.png",
  "silo-finance.jpg",
  "delta-prime.svg",
  "toros-solona.png",
  "toros-ethereum.png",
  "toros-finance.svg",
  "notional-finance.svg",
  "overnight.svg",
  "symbiotic.png",
  "etherfi.svg",
  "toros.png",
  "dialectic-moonphase.svg",
  "dialectic-chronograph.svg",
  "spectra.svg",
  "origin-ousd.svg",
  "mellow-p2p-market-symbiotic.svg",
  "mellow.jpg",
  "mellow-re7-labs-market-symbiotic.svg",
  "mellow-mev-capital-market-symbiotic.svg",
  "rsteth-symbiotic-mellow-pendle.svg",
  "amphreth-symbiotic-mellow-pendle.svg",
  "steaklrt-symbiotic-mellow-pendle.svg",
  "re7lrt-symbiotic-mellow-pendle.svg",
  "inverse-finance-firm.svg",
  "inverse-finance-sdola.png",
  "etherfi-liquid-king-karak-lrt-vault.svg",
  "beefy-clm-velodrome.svg",
  "beefy.svg",
  "beefy-clm-camelot.svg",
  "beefy-clm-pancakeswap.svg",
  "curve-llamalend.svg",
  "ramses-exchange.png",
  "credit-guild.jpg",
  "reserve.png",
  "contango.jpg",
  "flat-money.svg",
  "flat-money.svg",
  "etherfi-liquid-ebtc-bitcoin-lrt-vault.svg",
  "contango-compound.svg",
  "contango-aave.svg",
  "contango.jpg",
  "pancake-swap.svg",
  "beefy-velodrome.svg",
  "base.svg",
  "blue-chip-euler-v2-markets.svg",
  "blue-chip-morpho-vaults.svg",
  "ajna-finance.svg",
  "dolomite.jpg",
  "steer-protocol.jpg",
  "relative-finance.svg",
  "ao-staking.svg",
  "gamma-swap.png",
  "etherfi-liquid-usual-stable-vault.svg",
  "etherfi-liquid-elixir-stable-vault.svg",
  "sUSDS.svg",
  "everstake.jpg",
  "ensuro.svg",
  "scrvusd.svg",
  "lombard-finance.svg",
  "liquity-v2.svg",
  "cow-amm.svg",
  "entry-plan.svg",
  "essential-plan.svg",
  "elite-plan.svg",
  "pendle.svg",
  "sparkdex.png",
  "fasanara.svg",
  "term-finance.png",
  "sturdy-finance.svg",
  "ethena-usde-depeg.svg",
  "maple.svg",
  "syrup.svg",
  "uniswap4.svg",
  "balancer-v3.svg",
  "rfx.svg",
  "bittensor.svg",
  "defi-covered.svg",
  "sky-usds-depeg.svg",
  "lvlUSD-depeg.jpg",
  "USDT0-depeg.svg",
  "USR-depeg.svg",
  "tETH-depeg.svg",
  "superoeth-depeg.svg",
  "wbtc-depeg.svg",
  "eBTC-depeg.png",
  "vffat-depeg.png",
  "entry-plan.svg",
  "essential-plan.svg",
  "elite-plan.svg",
  "l1.svg",
  "figment-eth-slashing.svg",
  "pooltogether.svg",
  "coinbase.svg",
  "kraken.svg",
  "binance.svg",
  "OKX.svg",
  "deribit.jpg",
  "bitmex.png",
  "bybit.jpg",
  "shadow.svg",
  "cork.svg",
  "rings.svg",
  "inverse-dola-depeg.svg",
  "ensuro-yield.svg",
  "coinshift-usdl-morpho-vault.svg",
  "b-tier-morpho-vaults.svg",
  "b-tier-euler-v2-markets.svg",
  "oc-cover.svg",
  "usual-bug-bounty.svg",
  "reusd.svg",
  "origin.jpg",
  "byzantine-finance.png",
  "brava-conservative-cover.svg",
  "brava-balanced-cover.svg",
  "brava-advanced-cover.svg",
  "extrafi-xlend.svg",
  "ambient-finance.png",
  "kinetic.svg",
  "revert-finance.png",
  "wbtc-eusd-morpho-market.svg",
  "stackup.svg",
  "yo-protocol.png",
  "aave-v1.svg",
  "akropolis.svg",
  "alpha-homora.svg",
  "ampleforth.svg",
  "arbitrum.svg",
  "aurora.svg",
  "avalanche.svg",
  "bunnypancake.svg",
  "bzx.svg",
  "celo.svg",
  "celsius.svg",
  "cowswap.svg",
  "cream.svg",
  "cronos.svg",
  "dforce.svg",
  "dodo.svg",
  "element-finance.svg",
  "enzyme-v4.svg",
  "fantom.svg",
  "fuse.svg",
  "gamma.svg",
  "gnosis-multisig.svg",
  "harmony.svg",
  "heco.svg",
  "homora.svg",
  "idleDAIYield.svg",
  "idleUSDTYield.svg",
  "instadapp.svg",
  "ironbank.svg",
  "maker-sai.svg",
  "metis.svg",
  "moonbeam.svg",
  "mooniswap.svg",
  "moonriver.svg",
  "nexus-mutual.svg",
  "nucypher.svg",
  "nuo.png",
  "ondo.svg",
  "optimism.svg",
  "pancakeswap.svg",
  "polkadot.svg",
  "polygon.svg",
  "popsicle.svg",
  "ren.svg",
  "solana.svg",
  "starkware.svg",
  "tbtc.svg",
  "terra-chain.svg",
  "uma.svg",
  "uniswap-v1.svg",
  "venus.svg",
  "vesper-veth.svg",
  "zksync.svg"
];
var allLogoNames = [
  "zerox",
  "oneinch",
  "aavev2",
  "abracadabra",
  "alchemix",
  "anchor",
  "angle",
  "argent",
  "aura",
  "babylon",
  "badgerdao",
  "balancer",
  "bancor",
  "bancor",
  "beefy",
  "binance",
  "blockFi",
  "gelt",
  "centrifuge",
  "coinbase",
  "compoundv2",
  "convex",
  "convex",
  "convex",
  "crypto-com",
  "curve",
  "curve",
  "curve",
  "dydx",
  "ease",
  "enzyme",
  "enzyme",
  "eth",
  "euler",
  "fodl",
  "ftx",
  "gearbox",
  "gemini",
  "gmx",
  "goldfinch",
  "hodlnaut",
  "kraken",
  "ledn",
  "liquidcollective",
  "liquity",
  "sky-money",
  "mstable",
  "nested",
  "nexo",
  "notional-finance",
  "olympusdao",
  "opyn",
  "originusd",
  "pangolin",
  "perpetual",
  "pooltogether",
  "premia",
  "rari",
  "reflexer",
  "ribbon",
  "gnosis-safe",
  "tokensets",
  "tokensets",
  "sherlock",
  "stakedao",
  "stakewise",
  "stakewise",
  "sushiswap",
  "synthetix",
  "thorchain",
  "lfj",
  "uniswapv2",
  "uniswapv2",
  "vector",
  "vesper",
  "yearn",
  "yearn",
  "yeti",
  "yield-app",
  "alpaca",
  "wefi",
  "exactly",
  "etherfi",
  "squeeth-by-opyn",
  "rage-trade",
  "sentiment",
  "lyra",
  "perennial",
  "liquify",
  "lyra",
  "buffer-finance",
  "hook",
  "holyheld",
  "union-finance",
  "openq",
  "level-finance",
  "offramp",
  "aavev3",
  "morpho",
  "chorusone",
  "kiln",
  "vertex",
  "the-retail-mutual",
  "figment",
  "teller",
  "ajna",
  "eigenlayer",
  "vox",
  "mahalend",
  "self",
  "scallop",
  "wefi",
  "zktsunami",
  "hats",
  "sdai",
  "spark-lending",
  "defi-edge",
  "stakewisev3",
  "compoundv3",
  "deprecated",
  "deprecated",
  "deprecated",
  "deprecated",
  "yearn",
  "velodrome",
  "gmxv2",
  "dhedge",
  "term-finance",
  "pendle",
  "aerodrome",
  "hyperliquid",
  "maverick",
  "equilibria",
  "camelot",
  "nftperp",
  "gearbox",
  "pxeth",
  "fx-protocol",
  "prisma",
  "beethovenx",
  "arrakis",
  "yearn-v3",
  "synthetix-ecosystem",
  "eigenlayer-etherfi-pendle",
  "beefy-curve",
  "beefy-compoundv3",
  "beefy-balancerv2-aura",
  "notional-finance",
  "fraxlend",
  "morpho",
  "etherfi",
  "arcadia",
  "fx-protocol",
  "eigenlayer-kelp-pendle",
  "eigenlayer-renzo-pendle",
  "eigenlayer-swell-pendle",
  "arcadia",
  "derive",
  "renzo",
  "liquidcollective",
  "etherfi-zircuit-pendle",
  "kelpdao-zircuit-pendle",
  "renzo-zircuit-pendle",
  "pocket-universe",
  "request-finance",
  "etherfi",
  "superform",
  "etherfi",
  "beefy-uniswap",
  "rockX",
  "sUSDe-pendle",
  "sUSDe-karak-pendle",
  "steakhouse-morpho",
  "re7-morpho",
  "index-coop",
  "gauntlet-morpho",
  "etherfi-karak-pendle",
  "eigenlayer-puffer-pendle",
  "eigenlayer-bedrock-pendle",
  "crvUSD-silo-pendle",
  "block-analitica-morpho",
  "beefy-aerodrome",
  "extrafi",
  "moonwell",
  "instadapp-fluid",
  "silo-finance",
  "delta-prime",
  "toros-solona",
  "toros-ethereum",
  "toros-finance",
  "notional-finance",
  "overnight",
  "symbiotic",
  "etherfi",
  "toros",
  "dialectic-moonphase",
  "dialectic-chronograph",
  "spectra",
  "origin-ousd",
  "mellow-p2p-market-symbiotic",
  "mellow",
  "mellow-re7-labs-market-symbiotic",
  "mellow-mev-capital-market-symbiotic",
  "rsteth-symbiotic-mellow-pendle",
  "amphreth-symbiotic-mellow-pendle",
  "steaklrt-symbiotic-mellow-pendle",
  "re7lrt-symbiotic-mellow-pendle",
  "inverse-finance-firm",
  "inverse-finance-sdola",
  "etherfi-liquid-king-karak-lrt-vault",
  "beefy-clm-velodrome",
  "beefy",
  "beefy-clm-camelot",
  "beefy-clm-pancakeswap",
  "curve-llamalend",
  "ramses-exchange",
  "credit-guild",
  "reserve",
  "contango",
  "flat-money",
  "flat-money",
  "etherfi-liquid-ebtc-bitcoin-lrt-vault",
  "contango-compound",
  "contango-aave",
  "contango",
  "pancake-swap",
  "beefy-velodrome",
  "base",
  "blue-chip-euler-v2-markets",
  "blue-chip-morpho-vaults",
  "ajna-finance",
  "dolomite",
  "steer-protocol",
  "relative-finance",
  "ao-staking",
  "gamma-swap",
  "etherfi-liquid-usual-stable-vault",
  "etherfi-liquid-elixir-stable-vault",
  "sUSDS",
  "everstake",
  "ensuro",
  "scrvusd",
  "lombard-finance",
  "liquity-v2",
  "cow-amm",
  "entry-plan",
  "essential-plan",
  "elite-plan",
  "pendle",
  "sparkdex",
  "fasanara",
  "term-finance",
  "sturdy-finance",
  "ethena-usde-depeg",
  "maple",
  "syrup",
  "uniswap4",
  "balancer-v3",
  "rfx",
  "bittensor",
  "defi-covered",
  "sky-usds-depeg",
  "lvlUSD-depeg",
  "USDT0-depeg",
  "USR-depeg",
  "tETH-depeg",
  "superoeth-depeg",
  "wbtc-depeg",
  "eBTC-depeg",
  "vffat-depeg",
  "entry-plan",
  "essential-plan",
  "elite-plan",
  "l1",
  "figment-eth-slashing",
  "pooltogether",
  "coinbase",
  "kraken",
  "binance",
  "OKX",
  "deribit",
  "bitmex",
  "bybit",
  "shadow",
  "cork",
  "rings",
  "inverse-dola-depeg",
  "ensuro-yield",
  "coinshift-usdl-morpho-vault",
  "b-tier-morpho-vaults",
  "b-tier-euler-v2-markets",
  "oc-cover",
  "usual-bug-bounty",
  "reusd",
  "origin",
  "byzantine-finance",
  "brava-conservative-cover",
  "brava-balanced-cover",
  "brava-advanced-cover",
  "extrafi-xlend",
  "ambient-finance",
  "kinetic",
  "revert-finance",
  "wbtc-eusd-morpho-market",
  "stackup",
  "yo-protocol",
  "aave-v1",
  "akropolis",
  "alpha-homora",
  "ampleforth",
  "arbitrum",
  "aurora",
  "avalanche",
  "bunnypancake",
  "bzx",
  "celo",
  "celsius",
  "cowswap",
  "cream",
  "cronos",
  "dforce",
  "dodo",
  "element-finance",
  "enzyme-v4",
  "fantom",
  "fuse",
  "gamma",
  "gnosis-multisig",
  "harmony",
  "heco",
  "homora",
  "idleDAIYield",
  "idleUSDTYield",
  "instadapp",
  "ironbank",
  "maker-sai",
  "metis",
  "moonbeam",
  "mooniswap",
  "moonriver",
  "nexus-mutual",
  "nucypher",
  "nuo",
  "ondo",
  "optimism",
  "pancakeswap",
  "polkadot",
  "polygon",
  "popsicle",
  "ren",
  "solana",
  "starkware",
  "tbtc",
  "terra-chain",
  "uma",
  "uniswap-v1",
  "venus",
  "vesper-veth",
  "zksync"
];
var ProductTypes = /* @__PURE__ */ ((ProductTypes2) => {
  ProductTypes2[ProductTypes2["protocol"] = 0] = "protocol";
  ProductTypes2[ProductTypes2["custody"] = 1] = "custody";
  ProductTypes2[ProductTypes2["yieldToken"] = 2] = "yieldToken";
  ProductTypes2[ProductTypes2["sherlockExcess"] = 3] = "sherlockExcess";
  ProductTypes2[ProductTypes2["stakewiseEthStaking"] = 4] = "stakewiseEthStaking";
  ProductTypes2[ProductTypes2["liquidCollectiveEthStaking"] = 5] = "liquidCollectiveEthStaking";
  ProductTypes2[ProductTypes2["ethSlashing"] = 6] = "ethSlashing";
  ProductTypes2[ProductTypes2["sherlockQuotaShare"] = 7] = "sherlockQuotaShare";
  ProductTypes2[ProductTypes2["nativeProtocol"] = 8] = "nativeProtocol";
  ProductTypes2[ProductTypes2["theRetailMutual"] = 9] = "theRetailMutual";
  ProductTypes2[ProductTypes2["unoReQuotaShare"] = 10] = "unoReQuotaShare";
  ProductTypes2[ProductTypes2["bundledProtocol"] = 11] = "bundledProtocol";
  ProductTypes2[ProductTypes2["ethSlashingUmbrella"] = 12] = "ethSlashingUmbrella";
  ProductTypes2[ProductTypes2["openCoverTransaction"] = 13] = "openCoverTransaction";
  ProductTypes2[ProductTypes2["fundPortfolio"] = 14] = "fundPortfolio";
  ProductTypes2[ProductTypes2["sherlockBugBounty"] = 15] = "sherlockBugBounty";
  ProductTypes2[ProductTypes2["deFiPass"] = 16] = "deFiPass";
  ProductTypes2[ProductTypes2["followOn"] = 17] = "followOn";
  ProductTypes2[ProductTypes2["immunefiBugBounty"] = 18] = "immunefiBugBounty";
  ProductTypes2[ProductTypes2["nexusMutual"] = 19] = "nexusMutual";
  ProductTypes2[ProductTypes2["generalisedFundPortfolio"] = 20] = "generalisedFundPortfolio";
  ProductTypes2[ProductTypes2["crypto"] = 21] = "crypto";
  ProductTypes2[ProductTypes2["nativeSyndicate"] = 22] = "nativeSyndicate";
  ProductTypes2[ProductTypes2["spearbitCantina"] = 23] = "spearbitCantina";
  return ProductTypes2;
})(ProductTypes || {});

// src/constants/buyCover.ts
var CoverAsset = /* @__PURE__ */ ((CoverAsset2) => {
  CoverAsset2[CoverAsset2["ETH"] = 0] = "ETH";
  CoverAsset2[CoverAsset2["DAI"] = 1] = "DAI";
  CoverAsset2[CoverAsset2["USDC"] = 6] = "USDC";
  CoverAsset2[CoverAsset2["cbBTC"] = 7] = "cbBTC";
  return CoverAsset2;
})(CoverAsset || {});
var PaymentAsset = /* @__PURE__ */ ((PaymentAsset2) => {
  PaymentAsset2[PaymentAsset2["ETH"] = 0] = "ETH";
  PaymentAsset2[PaymentAsset2["DAI"] = 1] = "DAI";
  PaymentAsset2[PaymentAsset2["USDC"] = 6] = "USDC";
  PaymentAsset2[PaymentAsset2["cbBTC"] = 7] = "cbBTC";
  PaymentAsset2[PaymentAsset2["NXM"] = 255] = "NXM";
  return PaymentAsset2;
})(PaymentAsset || {});
var CoverId = /* @__PURE__ */ ((CoverId2) => {
  CoverId2[CoverId2["BUY"] = 0] = "BUY";
  return CoverId2;
})(CoverId || {});
var COMMISSION_DENOMINATOR = 1e4;
var SLIPPAGE_DENOMINATOR = 1e4;
var TARGET_PRICE_DENOMINATOR = 1e4;
var MINIMUM_COVER_PERIOD = 28;
var MAXIMUM_COVER_PERIOD = 365;
var DEFAULT_SLIPPAGE = 10;
var DEFAULT_COMMISSION_RATIO = 1500;
var SHERLOCK_BUG_BOUNTY_COMMISSION_RATIO = 500;
var TRM_COMMISSION_RATIO = 1e3;
var FUND_PORTFOLIO_COMMISSION_RATIO = 1e3;
var DEFI_PASS_COMMISSION_RATIO = 1e3;
var GENERALISED_FUND_PORTFOLIO_COMMISSION_RATIO = 1e3;
var CRYPTO_COVER_COMMISSION_RATIO = 1e3;
var NEXUS_MUTUAL_COVER_COMMISSION_RATIO = 1e3;
var NO_COMMISSION = 0;
var NO_COMMISSION_DESTINATION = zeroAddress;
var UNITY_ADDRESS = "0x95aBC2A62eE543217CF7640B277BA13D056d904A";
var NEXUS_MUTUAL_DAO_TREASURY_ADDRESS = "0x8e53D04644E9ab0412a8c6bd228C84da7664cFE3";
var IMMUNEFI_ADDRESS = "0x9c2F47079eb7Def5dd01Dd7E1138583f82376bDc";
var SPEARBIT_CANTINA_ADDRESS = "0x3Dcb7CFbB431A11CAbb6f7F2296E2354f488Efc2";
var BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE = {
  [6 /* ethSlashing */]: DEFAULT_COMMISSION_RATIO,
  [5 /* liquidCollectiveEthStaking */]: DEFAULT_COMMISSION_RATIO,
  [4 /* stakewiseEthStaking */]: DEFAULT_COMMISSION_RATIO,
  [7 /* sherlockQuotaShare */]: DEFAULT_COMMISSION_RATIO,
  [10 /* unoReQuotaShare */]: DEFAULT_COMMISSION_RATIO,
  [9 /* theRetailMutual */]: TRM_COMMISSION_RATIO,
  [0 /* protocol */]: DEFAULT_COMMISSION_RATIO,
  [11 /* bundledProtocol */]: DEFAULT_COMMISSION_RATIO,
  [1 /* custody */]: DEFAULT_COMMISSION_RATIO,
  [2 /* yieldToken */]: DEFAULT_COMMISSION_RATIO,
  [3 /* sherlockExcess */]: DEFAULT_COMMISSION_RATIO,
  [8 /* nativeProtocol */]: DEFAULT_COMMISSION_RATIO,
  [12 /* ethSlashingUmbrella */]: DEFAULT_COMMISSION_RATIO,
  [13 /* openCoverTransaction */]: DEFAULT_COMMISSION_RATIO,
  [14 /* fundPortfolio */]: FUND_PORTFOLIO_COMMISSION_RATIO,
  [15 /* sherlockBugBounty */]: SHERLOCK_BUG_BOUNTY_COMMISSION_RATIO,
  [16 /* deFiPass */]: DEFI_PASS_COMMISSION_RATIO,
  [17 /* followOn */]: NO_COMMISSION,
  [18 /* immunefiBugBounty */]: DEFAULT_COMMISSION_RATIO,
  [19 /* nexusMutual */]: NEXUS_MUTUAL_COVER_COMMISSION_RATIO,
  [20 /* generalisedFundPortfolio */]: GENERALISED_FUND_PORTFOLIO_COMMISSION_RATIO,
  [21 /* crypto */]: CRYPTO_COVER_COMMISSION_RATIO,
  [22 /* nativeSyndicate */]: NO_COMMISSION,
  [23 /* spearbitCantina */]: DEFAULT_COMMISSION_RATIO
};
var BUY_COVER_COMMISSION_DESTINATION_BY_PRODUCT_TYPE = {
  [6 /* ethSlashing */]: UNITY_ADDRESS,
  [5 /* liquidCollectiveEthStaking */]: UNITY_ADDRESS,
  [4 /* stakewiseEthStaking */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [7 /* sherlockQuotaShare */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [10 /* unoReQuotaShare */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [9 /* theRetailMutual */]: UNITY_ADDRESS,
  [0 /* protocol */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [11 /* bundledProtocol */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [1 /* custody */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [2 /* yieldToken */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [3 /* sherlockExcess */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [8 /* nativeProtocol */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [12 /* ethSlashingUmbrella */]: UNITY_ADDRESS,
  [13 /* openCoverTransaction */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [14 /* fundPortfolio */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [15 /* sherlockBugBounty */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [16 /* deFiPass */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [17 /* followOn */]: NO_COMMISSION_DESTINATION,
  [18 /* immunefiBugBounty */]: IMMUNEFI_ADDRESS,
  [19 /* nexusMutual */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [20 /* generalisedFundPortfolio */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [21 /* crypto */]: NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  [22 /* nativeSyndicate */]: NO_COMMISSION_DESTINATION,
  [23 /* spearbitCantina */]: SPEARBIT_CANTINA_ADDRESS
};

// src/buyCover/calculatePremiumWithCommissionAndSlippage.ts
var calculatePremiumWithCommissionAndSlippage = (premium, commission = 0, slippage = 0) => {
  const premiumWithCommission = premium * BigInt(COMMISSION_DENOMINATOR) / BigInt(COMMISSION_DENOMINATOR - commission);
  const premiumWithCommissionAndSlippage = premiumWithCommission * BigInt(SLIPPAGE_DENOMINATOR + slippage) / BigInt(SLIPPAGE_DENOMINATOR);
  return premiumWithCommissionAndSlippage;
};

// src/constants/index.ts
var constants_exports = {};
__export(constants_exports, {
  BUY_COVER_COMMISSION_DESTINATION_BY_PRODUCT_TYPE: () => BUY_COVER_COMMISSION_DESTINATION_BY_PRODUCT_TYPE,
  BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE: () => BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE,
  COMMISSION_DENOMINATOR: () => COMMISSION_DENOMINATOR,
  CRYPTO_COVER_COMMISSION_RATIO: () => CRYPTO_COVER_COMMISSION_RATIO,
  CoverAsset: () => CoverAsset,
  CoverId: () => CoverId,
  DEFAULT_COMMISSION_RATIO: () => DEFAULT_COMMISSION_RATIO,
  DEFAULT_SLIPPAGE: () => DEFAULT_SLIPPAGE,
  DEFI_PASS_COMMISSION_RATIO: () => DEFI_PASS_COMMISSION_RATIO,
  FUND_PORTFOLIO_COMMISSION_RATIO: () => FUND_PORTFOLIO_COMMISSION_RATIO,
  GENERALISED_FUND_PORTFOLIO_COMMISSION_RATIO: () => GENERALISED_FUND_PORTFOLIO_COMMISSION_RATIO,
  IMMUNEFI_ADDRESS: () => IMMUNEFI_ADDRESS,
  MAXIMUM_COVER_PERIOD: () => MAXIMUM_COVER_PERIOD,
  MINIMUM_COVER_PERIOD: () => MINIMUM_COVER_PERIOD,
  NEXUS_MUTUAL_COVER_COMMISSION_RATIO: () => NEXUS_MUTUAL_COVER_COMMISSION_RATIO,
  NEXUS_MUTUAL_DAO_TREASURY_ADDRESS: () => NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  NO_COMMISSION: () => NO_COMMISSION,
  NO_COMMISSION_DESTINATION: () => NO_COMMISSION_DESTINATION,
  PaymentAsset: () => PaymentAsset,
  ProductCategoryEnum: () => ProductCategoryEnum,
  SHERLOCK_BUG_BOUNTY_COMMISSION_RATIO: () => SHERLOCK_BUG_BOUNTY_COMMISSION_RATIO,
  SLIPPAGE_DENOMINATOR: () => SLIPPAGE_DENOMINATOR,
  SPEARBIT_CANTINA_ADDRESS: () => SPEARBIT_CANTINA_ADDRESS,
  TARGET_PRICE_DENOMINATOR: () => TARGET_PRICE_DENOMINATOR,
  TRM_COMMISSION_RATIO: () => TRM_COMMISSION_RATIO,
  UNITY_ADDRESS: () => UNITY_ADDRESS,
  allPrivateProductsIds: () => allPrivateProductsIds,
  categoryLabelByEnum: () => categoryLabelByEnum,
  productCategoryMap: () => productCategoryMap
});

// src/constants/products.ts
var ProductCategoryEnum = /* @__PURE__ */ ((ProductCategoryEnum2) => {
  ProductCategoryEnum2["Lending"] = "lending";
  ProductCategoryEnum2["Dex"] = "dex";
  ProductCategoryEnum2["LiquidRestaking"] = "liquid-restaking";
  ProductCategoryEnum2["YieldOptimizer"] = "yield-optimizer";
  ProductCategoryEnum2["Perpetuals"] = "perpetuals";
  ProductCategoryEnum2["SmartWallet"] = "smart-wallet";
  ProductCategoryEnum2["ETHStaking"] = "eth-staking";
  ProductCategoryEnum2["Depeg"] = "depeg";
  ProductCategoryEnum2["Custody"] = "custody";
  ProductCategoryEnum2["Uncategorized"] = "uncategorized";
  return ProductCategoryEnum2;
})(ProductCategoryEnum || {});
var categoryLabelByEnum = {
  ["lending" /* Lending */]: "Lending",
  ["dex" /* Dex */]: "DEX",
  ["liquid-restaking" /* LiquidRestaking */]: "Liquid Restaking",
  ["yield-optimizer" /* YieldOptimizer */]: "Yield Optimizer",
  ["perpetuals" /* Perpetuals */]: "Perpetuals",
  ["smart-wallet" /* SmartWallet */]: "Smart Wallet",
  ["eth-staking" /* ETHStaking */]: "ETH Staking",
  ["depeg" /* Depeg */]: "Depeg",
  ["custody" /* Custody */]: "Custody",
  ["uncategorized" /* Uncategorized */]: "Uncategorized"
};
var productCategoryMap = {
  1: "dex" /* Dex */,
  // 1Inch (DEX & Liquidity Pools)
  2: "lending" /* Lending */,
  // Aave v2
  3: "lending" /* Lending */,
  // Abracadabra v1
  4: "yield-optimizer" /* YieldOptimizer */,
  // Alchemix v2
  5: "uncategorized" /* Uncategorized */,
  // Anchor (deprecated)
  6: "lending" /* Lending */,
  // Angle v1
  7: "smart-wallet" /* SmartWallet */,
  // Argent
  8: "yield-optimizer" /* YieldOptimizer */,
  // Aura v1
  9: "uncategorized" /* Uncategorized */,
  // Babylon Finance (deprecated)
  10: "uncategorized" /* Uncategorized */,
  // BadgerDAO v1 (deprecated)
  11: "dex" /* Dex */,
  // Balancer v2
  12: "uncategorized" /* Uncategorized */,
  // Bancor v2 (deprecated)
  13: "uncategorized" /* Uncategorized */,
  // Bancor v3 (deprecated)
  14: "yield-optimizer" /* YieldOptimizer */,
  // Beefy v2
  15: "uncategorized" /* Uncategorized */,
  // Binance (deprecated)
  16: "uncategorized" /* Uncategorized */,
  // BlockFi (deprecated)
  17: "uncategorized" /* Uncategorized */,
  // Bundle: Gelt + mStable + Aave v2
  18: "uncategorized" /* Uncategorized */,
  // Centrifuge Tinlake (deprecated)
  19: "uncategorized" /* Uncategorized */,
  // Coinbase (deprecated)
  20: "lending" /* Lending */,
  // Compound v2
  21: "uncategorized" /* Uncategorized */,
  // Convex 3CRV (cvx3CRV) (deprecated)
  22: "yield-optimizer" /* YieldOptimizer */,
  // Convex Finance v1
  23: "uncategorized" /* Uncategorized */,
  // Convex stethCrv (cvxstethCrv) (deprecated)
  24: "uncategorized" /* Uncategorized */,
  // Crypto.com (deprecated)
  25: "uncategorized" /* Uncategorized */,
  // Curve 3pool LP (3Crv) (deprecated)
  26: "dex" /* Dex */,
  // Curve All Pools (incl staking)
  27: "uncategorized" /* Uncategorized */,
  // Curve sETH LP (eCrv) (deprecated)
  28: "perpetuals" /* Perpetuals */,
  // dydx Perpetual
  29: "uncategorized" /* Uncategorized */,
  // Ease v1
  30: "uncategorized" /* Uncategorized */,
  // Enzyme v3 (deprecated)
  31: "yield-optimizer" /* YieldOptimizer */,
  // Enzyme v4
  32: "uncategorized" /* Uncategorized */,
  // Eth 2.0 (deposit contract) (deprecated)
  33: "uncategorized" /* Uncategorized */,
  // Euler (deprecated)
  34: "perpetuals" /* Perpetuals */,
  // FODL v1
  35: "uncategorized" /* Uncategorized */,
  // FTX (deprecated)
  36: "lending" /* Lending */,
  // Gearbox v2
  37: "uncategorized" /* Uncategorized */,
  // Gemini (deprecated)
  38: "perpetuals" /* Perpetuals */,
  // GMX v1
  39: "lending" /* Lending */,
  // Goldfinch v1
  40: "uncategorized" /* Uncategorized */,
  // Hodlnaut (deprecated)
  41: "uncategorized" /* Uncategorized */,
  // Kraken (deprecated)
  42: "uncategorized" /* Uncategorized */,
  // Ledn (deprecated)
  43: "uncategorized" /* Uncategorized */,
  // Liquid Collective (deprecated)
  44: "lending" /* Lending */,
  // Liquity v1
  45: "lending" /* Lending */,
  // Sky Money
  46: "uncategorized" /* Uncategorized */,
  // mStable (deprecated)
  47: "uncategorized" /* Uncategorized */,
  // Nested v1 (deprecated)
  48: "uncategorized" /* Uncategorized */,
  // Nexo (deprecated)
  49: "lending" /* Lending */,
  // Notional Finance v2
  50: "uncategorized" /* Uncategorized */,
  // OlympusDAO (deprecated)
  51: "perpetuals" /* Perpetuals */,
  // Opyn v2
  52: "uncategorized" /* Uncategorized */,
  // Origin OUSD (deprecated)
  53: "dex" /* Dex */,
  // Pangolin v1
  54: "perpetuals" /* Perpetuals */,
  // Perpetual Protocol v2
  55: "uncategorized" /* Uncategorized */,
  // Pool Together v4 (deprecated)
  56: "uncategorized" /* Uncategorized */,
  // Premia Finance (deprecated)
  57: "uncategorized" /* Uncategorized */,
  // Rari Capital (deprecated)
  58: "lending" /* Lending */,
  // Reflexer v1
  59: "perpetuals" /* Perpetuals */,
  // Aevo
  60: "smart-wallet" /* SmartWallet */,
  // Safe (formerly Gnosis Safe)
  61: "uncategorized" /* Uncategorized */,
  // Set Protocol (deprecated)
  62: "yield-optimizer" /* YieldOptimizer */,
  // Set Protocol v2
  63: "uncategorized" /* Uncategorized */,
  // Stakewise(?)
  64: "yield-optimizer" /* YieldOptimizer */,
  // Stake DAO v1
  65: "uncategorized" /* Uncategorized */,
  // Stakewise 3rd party (3 ETH/validator) (deprecated)
  66: "uncategorized" /* Uncategorized */,
  // Stakewise operated (3 ETH/validator) (deprecated)
  67: "dex" /* Dex */,
  // SushiSwap v1
  68: "perpetuals" /* Perpetuals */,
  // Synthetix
  69: "uncategorized" /* Uncategorized */,
  // THORChain (Thorchain Network) (deprecated)
  70: "dex" /* Dex */,
  // LFJ
  71: "dex" /* Dex */,
  // Uniswap v2
  72: "dex" /* Dex */,
  // Uniswap v3
  73: "yield-optimizer" /* YieldOptimizer */,
  // Vector v1
  74: "yield-optimizer" /* YieldOptimizer */,
  // Vesper v3
  75: "yield-optimizer" /* YieldOptimizer */,
  // Yearn Finance v2 (all vaults)
  76: "uncategorized" /* Uncategorized */,
  // Yearn yvUSDC v2 (deprecated)
  77: "lending" /* Lending */,
  // Yeti Finance v1
  78: "uncategorized" /* Uncategorized */,
  // Yield App (deprecated)
  79: "yield-optimizer" /* YieldOptimizer */,
  // Alpaca Finance v1
  80: "lending" /* Lending */,
  // WeFi v1
  81: "lending" /* Lending */,
  // Exactly
  82: "uncategorized" /* Uncategorized */,
  // EtherFi 5ETH
  83: "uncategorized" /* Uncategorized */,
  // Squeeth by Opyn (Sherlock)
  84: "uncategorized" /* Uncategorized */,
  // Rage Trade (Sherlock)
  85: "uncategorized" /* Uncategorized */,
  // Sentiment (Sherlock)
  86: "uncategorized" /* Uncategorized */,
  // Lyra Newport (Sherlock)
  87: "uncategorized" /* Uncategorized */,
  // Perennial (Sherlock)
  88: "uncategorized" /* Uncategorized */,
  // LiquiFi (Sherlock)
  89: "uncategorized" /* Uncategorized */,
  // Lyra Avalon (Sherlock)
  90: "uncategorized" /* Uncategorized */,
  // Buffer Finance (Sherlock)
  91: "uncategorized" /* Uncategorized */,
  // Hook (Sherlock)
  92: "uncategorized" /* Uncategorized */,
  // Holyheld (Sherlock)
  93: "uncategorized" /* Uncategorized */,
  // Union Finance (Sherlock)
  94: "uncategorized" /* Uncategorized */,
  // OpenQ (Sherlock)
  95: "perpetuals" /* Perpetuals */,
  // Level Finance v1
  96: "dex" /* Dex */,
  // Offramp.xyz v1
  97: "lending" /* Lending */,
  // Aave v3
  98: "yield-optimizer" /* YieldOptimizer */,
  // Morpho Optimisers v1 (deprecated)
  99: "uncategorized" /* Uncategorized */,
  // Chorus One
  100: "uncategorized" /* Uncategorized */,
  // Kiln
  101: "uncategorized" /* Uncategorized */,
  // Vertex (Native Protocol)
  102: "uncategorized" /* Uncategorized */,
  // The Retail Mutual
  103: "eth-staking" /* ETHStaking */,
  // Figment
  104: "uncategorized" /* Uncategorized */,
  // Teller (Sherlock)
  105: "uncategorized" /* Uncategorized */,
  // Ajna (Sherlock)
  106: "liquid-restaking" /* LiquidRestaking */,
  // EigenLayer v1
  107: "uncategorized" /* Uncategorized */,
  // Vox Finance (UnoRe)
  108: "uncategorized" /* Uncategorized */,
  // MahaLend (UnoRe)
  109: "uncategorized" /* Uncategorized */,
  // SELF (UnoRe)
  110: "uncategorized" /* Uncategorized */,
  // Scallop (UnoRe)
  111: "uncategorized" /* Uncategorized */,
  // WeFi (UnoRe)
  112: "uncategorized" /* Uncategorized */,
  // ZkTsunami (UnoRe)
  113: "uncategorized" /* Uncategorized */,
  // Hats Protocol
  114: "yield-optimizer" /* YieldOptimizer */,
  // DAI Savings Rate (sDAI)
  115: "lending" /* Lending */,
  // Spark Lending v1
  116: "yield-optimizer" /* YieldOptimizer */,
  // DefiEdge
  117: "eth-staking" /* ETHStaking */,
  // Stakewise v3
  118: "lending" /* Lending */,
  // Compound v3
  123: "yield-optimizer" /* YieldOptimizer */,
  // Yearn v3
  124: "dex" /* Dex */,
  // Velodrome
  125: "perpetuals" /* Perpetuals */,
  // GMX v2
  126: "yield-optimizer" /* YieldOptimizer */,
  // dHedge
  127: "lending" /* Lending */,
  // Term Finance
  128: "yield-optimizer" /* YieldOptimizer */,
  // Pendle
  129: "dex" /* Dex */,
  // Aerodrome
  130: "perpetuals" /* Perpetuals */,
  // Hyperliquid
  131: "dex" /* Dex */,
  // Maverick
  132: "yield-optimizer" /* YieldOptimizer */,
  // Equilibria
  133: "dex" /* Dex */,
  // Camelot
  134: "lending" /* Lending */,
  // NFTperp
  135: "lending" /* Lending */,
  // Gearbox v3
  136: "eth-staking" /* ETHStaking */,
  // pxETH
  137: "lending" /* Lending */,
  // fx Protocol
  138: "lending" /* Lending */,
  // Prisma
  139: "dex" /* Dex */,
  // Beethoven X
  140: "yield-optimizer" /* YieldOptimizer */,
  // Arrakis
  141: "yield-optimizer" /* YieldOptimizer */,
  // Yearn v3
  142: "perpetuals" /* Perpetuals */,
  // Synthetix Ecosystem
  143: "liquid-restaking" /* LiquidRestaking */,
  // EigenLayer + Ether.fi + Pendle (deprecated)
  144: "yield-optimizer" /* YieldOptimizer */,
  // Beefy + Curve (deprecated)
  145: "yield-optimizer" /* YieldOptimizer */,
  // Beefy + Compound v3 (deprecated)
  146: "yield-optimizer" /* YieldOptimizer */,
  // Beefy + Balancer v2 + Aura (deprecated)
  147: "lending" /* Lending */,
  // Notional v3
  148: "lending" /* Lending */,
  // Fraxlend
  149: "lending" /* Lending */,
  // wstETH/USDC Market Morpho Blue (deprecated)
  150: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi Liquid ETH Vault
  151: "uncategorized" /* Uncategorized */,
  // Arcadia (Sherlock)
  152: "yield-optimizer" /* YieldOptimizer */,
  // fx Protocol
  153: "liquid-restaking" /* LiquidRestaking */,
  // EigenLayer + KelpDAO + Pendle (deprecated)
  154: "liquid-restaking" /* LiquidRestaking */,
  // EigenLayer + Renzo + Pendle (deprecated)
  155: "liquid-restaking" /* LiquidRestaking */,
  // EigenLayer + Swell + Pendle (deprecated)
  156: "yield-optimizer" /* YieldOptimizer */,
  // Arcadia
  157: "perpetuals" /* Perpetuals */,
  // Derive (formerly Lyra)
  158: "liquid-restaking" /* LiquidRestaking */,
  // Renzo
  159: "uncategorized" /* Uncategorized */,
  // Liquid Collective
  160: "liquid-restaking" /* LiquidRestaking */,
  // Etherfi (Zircuit) Pendle (deprecated)
  161: "liquid-restaking" /* LiquidRestaking */,
  // KelpDAO (Zircuit) Pendle (deprecated)
  162: "liquid-restaking" /* LiquidRestaking */,
  // Renzo (Zircuit) Pendle (deprecated)
  163: "uncategorized" /* Uncategorized */,
  // Pocket Universe
  164: "uncategorized" /* Uncategorized */,
  // Request Finance
  165: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi Liquid Market-Neutral USD Vault
  166: "yield-optimizer" /* YieldOptimizer */,
  // Superform
  167: "liquid-restaking" /* LiquidRestaking */,
  // Ether.fi
  168: "yield-optimizer" /* YieldOptimizer */,
  // Beefy CLM + Uniswap v3 (deprecated)
  169: "eth-staking" /* ETHStaking */,
  // RockX
  170: "yield-optimizer" /* YieldOptimizer */,
  // sUSDe Pendle (deprecated)
  171: "yield-optimizer" /* YieldOptimizer */,
  // sUSDe (Karak) Pendle (deprecated)
  172: "lending" /* Lending */,
  // Steakhouse MetaMorpho + Morpho Blue (deprecated)
  173: "lending" /* Lending */,
  // Re7 MetaMorpho + Morpho Blue (deprecated)
  174: "yield-optimizer" /* YieldOptimizer */,
  // Index Coop
  175: "lending" /* Lending */,
  // Gauntlet MetaMorpho + Morpho Blue (deprecated)
  176: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi (Karak) Pendle (deprecated)
  177: "yield-optimizer" /* YieldOptimizer */,
  // EigenLayer + Puffer + Pendle (deprecated)
  178: "yield-optimizer" /* YieldOptimizer */,
  // EigenLayer + Bedrock + Pendle (deprecated)
  179: "yield-optimizer" /* YieldOptimizer */,
  // crvUSD (Silo) Pendle (deprecated)
  180: "lending" /* Lending */,
  // Block Analitica/B.Protocol MetaMorpho + Morpho Blue (deprecated)
  181: "yield-optimizer" /* YieldOptimizer */,
  // Beefy + Aerodrome
  182: "yield-optimizer" /* YieldOptimizer */,
  // ExtraFi
  183: "lending" /* Lending */,
  // Moonwell
  184: "lending" /* Lending */,
  //  Instadapp Fluid
  185: "lending" /* Lending */,
  //  Silo Finance
  186: "uncategorized" /* Uncategorized */,
  // DeltaPrime (UnoRe)
  187: "yield-optimizer" /* YieldOptimizer */,
  // Toros Finance Solana Bull 3x (deprecated)
  188: "yield-optimizer" /* YieldOptimizer */,
  // Toros Finance Ethereum Bull 3x (deprecated)
  189: "yield-optimizer" /* YieldOptimizer */,
  // Toros Finance
  190: "lending" /* Lending */,
  // Notional v3
  191: "yield-optimizer" /* YieldOptimizer */,
  // Overnight Finance
  192: "liquid-restaking" /* LiquidRestaking */,
  // Symbiotic
  193: "yield-optimizer" /* YieldOptimizer */,
  // Etherfi Liquid Super Symbiotic LRT Vault
  194: "yield-optimizer" /* YieldOptimizer */,
  // Toros Finance Andromeda Yield (deprecated)
  195: "uncategorized" /* Uncategorized */,
  // Dialectic Moonphase
  196: "uncategorized" /* Uncategorized */,
  // Dialectic Chronograph
  197: "yield-optimizer" /* YieldOptimizer */,
  // Spectra
  198: "yield-optimizer" /* YieldOptimizer */,
  // Origin OUSD
  199: "liquid-restaking" /* LiquidRestaking */,
  // Mellow (P2P Market) + Symbiotic (deprecated)
  200: "liquid-restaking" /* LiquidRestaking */,
  // Mellow
  201: "liquid-restaking" /* LiquidRestaking */,
  // Mellow (Re7 Labs Market) + Symbiotic (deprecated)
  202: "liquid-restaking" /* LiquidRestaking */,
  // Mellow (MEV Capital Market) + Symbiotic (deprecated)
  203: "yield-optimizer" /* YieldOptimizer */,
  // rstETH Symbiotic + Mellow + Pendle (deprecated)
  204: "yield-optimizer" /* YieldOptimizer */,
  // amphrETH Symbiotic + Mellow + Pendle (deprecated)
  205: "yield-optimizer" /* YieldOptimizer */,
  // steakLRT Symbiotic + Mellow + Pendle (deprecated)
  206: "yield-optimizer" /* YieldOptimizer */,
  // Re7LRT Symbiotic + Mellow + Pendle (deprecated)
  207: "lending" /* Lending */,
  // Inverse Finance FiRM
  208: "yield-optimizer" /* YieldOptimizer */,
  // Inverse Finance sDOLA
  209: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi Liquid King Karak LRT Vault
  210: "yield-optimizer" /* YieldOptimizer */,
  // Beefy CLM + Velodrome (deprecated)
  211: "yield-optimizer" /* YieldOptimizer */,
  // Beefy
  212: "yield-optimizer" /* YieldOptimizer */,
  // Beefy CLM + Camelot (deprecated)
  213: "yield-optimizer" /* YieldOptimizer */,
  // Beefy CLM + PancakeSwap (deprecated)
  214: "lending" /* Lending */,
  // Curve LlamaLend
  215: "dex" /* Dex */,
  // Ramses Exchange
  216: "lending" /* Lending */,
  // Credit Guild
  217: "yield-optimizer" /* YieldOptimizer */,
  // Reserve
  218: "yield-optimizer" /* YieldOptimizer */,
  // Contango
  219: "uncategorized" /* Uncategorized */,
  // Flat Money (Sherlock) (deprecated)
  220: "uncategorized" /* Uncategorized */,
  // Flat Money
  221: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi Liquid eBTC Bitcoin LRT
  222: "yield-optimizer" /* YieldOptimizer */,
  // Contango + Compound v3 (deprecated)
  223: "yield-optimizer" /* YieldOptimizer */,
  // Contango + Aave v3 (deprecated)
  224: "yield-optimizer" /* YieldOptimizer */,
  // Contango
  225: "dex" /* Dex */,
  // PancakeSwap
  226: "yield-optimizer" /* YieldOptimizer */,
  // Beefy + Velodrome (deprecated)
  227: "uncategorized" /* Uncategorized */,
  // Base Defi Pass
  228: "lending" /* Lending */,
  // Blue Chip Euler v2 Markets
  229: "lending" /* Lending */,
  // Blue Chip Morpho Vaults
  230: "lending" /* Lending */,
  // Ajna Finance
  231: "lending" /* Lending */,
  // Dolomite
  232: "lending" /* Lending */,
  // Steer Protocol
  233: "uncategorized" /* Uncategorized */,
  // Relative Finance
  234: "yield-optimizer" /* YieldOptimizer */,
  // AO Staking
  235: "perpetuals" /* Perpetuals */,
  // GammaSwap
  236: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi Liquid Usual Stable Vault
  237: "yield-optimizer" /* YieldOptimizer */,
  // Ether.fi Liquid Elixir Stable Vault
  238: "yield-optimizer" /* YieldOptimizer */,
  // Sky Savings Rate (sUSDS)
  239: "uncategorized" /* Uncategorized */,
  // Everstake
  240: "uncategorized" /* Uncategorized */,
  // Ensuro
  241: "yield-optimizer" /* YieldOptimizer */,
  // Savings crvUSD (scrvUSD)
  242: "yield-optimizer" /* YieldOptimizer */,
  // Lombard DeFi Vault
  243: "lending" /* Lending */,
  // Liquity v2
  244: "dex" /* Dex */,
  // CoW AMM
  245: "uncategorized" /* Uncategorized */,
  // Entry Plan
  246: "uncategorized" /* Uncategorized */,
  // Essential Plan
  247: "uncategorized" /* Uncategorized */,
  // Elite Plan
  248: "yield-optimizer" /* YieldOptimizer */,
  // Pendle
  249: "dex" /* Dex */,
  // SparkDEX
  250: "uncategorized" /* Uncategorized */,
  // Fasanara
  251: "lending" /* Lending */,
  // Term Finance
  252: "yield-optimizer" /* YieldOptimizer */,
  // Sturdy Finance
  253: "depeg" /* Depeg */,
  // Ethena USDe Depeg
  254: "lending" /* Lending */,
  // Maple
  255: "lending" /* Lending */,
  // Syrup
  256: "dex" /* Dex */,
  // Uniswap v4
  257: "dex" /* Dex */,
  // Balancer v3
  258: "perpetuals" /* Perpetuals */,
  // RFX
  259: "uncategorized" /* Uncategorized */,
  // Bittensor
  260: "uncategorized" /* Uncategorized */,
  // DeFi Covered
  261: "depeg" /* Depeg */,
  // Sky USDS Depeg
  262: "depeg" /* Depeg */,
  // Level USD Depeg
  263: "depeg" /* Depeg */,
  // Tether USDT0 Depeg
  264: "depeg" /* Depeg */,
  // Resolv USR Depeg
  265: "depeg" /* Depeg */,
  // Treehouse ETH Depeg
  266: "depeg" /* Depeg */,
  // Super OETH Depeg
  267: "depeg" /* Depeg */,
  // WBTC Depeg
  268: "depeg" /* Depeg */,
  // Ether.fi eBTC Depeg
  269: "yield-optimizer" /* YieldOptimizer */,
  // vfat
  270: "uncategorized" /* Uncategorized */,
  // Entry Cover (deprecated)
  271: "uncategorized" /* Uncategorized */,
  // Essential Cover (deprecated)
  272: "uncategorized" /* Uncategorized */,
  // Elite Cover (deprecated)
  273: "uncategorized" /* Uncategorized */,
  // L1 Advisors Cover
  274: "uncategorized" /* Uncategorized */,
  // Figment ETH Slashing
  275: "yield-optimizer" /* YieldOptimizer */,
  // PoolTogether
  276: "custody" /* Custody */,
  // Coinbase
  277: "custody" /* Custody */,
  // Kraken
  278: "custody" /* Custody */,
  // Binance
  279: "custody" /* Custody */,
  // OKX
  280: "custody" /* Custody */,
  // Deribit
  281: "custody" /* Custody */,
  // Bitmex
  282: "custody" /* Custody */,
  // Bybit
  283: "dex" /* Dex */,
  // Shadow
  284: "uncategorized" /* Uncategorized */,
  // Cork
  285: "yield-optimizer" /* YieldOptimizer */,
  // Rings
  286: "depeg" /* Depeg */,
  // Inverse DOLA Depeg
  287: "uncategorized" /* Uncategorized */,
  // Ensuro Yield
  288: "lending" /* Lending */,
  // Coinshift USDL Morpho Vault
  289: "lending" /* Lending */,
  // B-Tier Morpho Vaults
  290: "lending" /* Lending */,
  // B-Tier Euler v2 Markets
  291: "uncategorized" /* Uncategorized */,
  // OC Cover
  292: "uncategorized" /* Uncategorized */,
  // Usual Bug Bounty
  293: "depeg" /* Depeg */,
  // Resupply USD (reUSD) Depeg
  294: "yield-optimizer" /* YieldOptimizer */,
  // Origin Sonic (OS)
  295: "liquid-restaking" /* LiquidRestaking */,
  // Byzantine Finance
  296: "uncategorized" /* Uncategorized */,
  // Brava Conservative Cover
  297: "uncategorized" /* Uncategorized */,
  // Brava Balanced Cover
  298: "uncategorized" /* Uncategorized */,
  // Brava Advanced Cover
  299: "lending" /* Lending */,
  // Extrafi Xlend
  300: "dex" /* Dex */,
  // Ambient Finance
  301: "lending" /* Lending */,
  // Kinetic
  302: "yield-optimizer" /* YieldOptimizer */,
  // Revert Finance
  303: "lending" /* Lending */,
  // WBTC / eUSD Morpho Market
  304: "smart-wallet" /* SmartWallet */,
  // Stackup
  305: "yield-optimizer" /* YieldOptimizer */
  // YO Protocol
};

// src/constants/index.ts
var { allPrivateProductsIds } = require_privateProducts();

// src/ipfs/index.ts
var ipfs_exports = {};
__export(ipfs_exports, {
  uploadIPFSContent: () => uploadIPFSContent,
  validateIPFSCid: () => validateIPFSCid,
  validateIPFSContent: () => validateIPFSContent
});

// src/ipfs/uploadIPFSContent.ts
import axios from "axios";

// src/ipfs/schemas.ts
import { z } from "zod";
var VERSION_1_0 = "1.0";
var VERSION_2_0 = "2.0";
var ethereumAddressRegex = /^0x[a-f0-9]{40}$/i;
var coverValidatorsSchema = z.object({
  version: z.literal(VERSION_1_0),
  validators: z.array(z.string().regex(ethereumAddressRegex, "Invalid Ethereum address")).min(1, "At least one validator address is required")
});
var coverQuotaShareSchema = z.object({
  version: z.literal(VERSION_1_0),
  quotaShare: z.number().min(0).max(100)
});
var coverAumCoverAmountPercentageSchema = z.object({
  version: z.literal(VERSION_1_0),
  aumCoverAmountPercentage: z.number().min(0).max(100)
});
var coverWalletAddressSchema = z.object({
  version: z.literal(VERSION_1_0),
  walletAddress: z.string().regex(ethereumAddressRegex, "Invalid Ethereum address")
});
var coverWalletAddressesSchema = z.discriminatedUnion("version", [
  z.object({
    version: z.literal(VERSION_1_0),
    walletAddresses: z.string().refine((val) => {
      const addresses = val.split(",").map((addr) => addr.trim());
      return addresses.every((addr) => ethereumAddressRegex.test(addr));
    }, "Invalid Ethereum address(es)")
  }),
  z.object({
    version: z.literal(VERSION_2_0),
    walletAddresses: z.array(z.string().regex(ethereumAddressRegex, "Invalid Ethereum address")).min(1, "At least one wallet address is required")
  })
]);
var coverFreeTextSchema = z.object({
  version: z.literal(VERSION_1_0),
  freeText: z.string().min(1, "Free text cannot be empty")
});
var coverDesignatedWalletsSchema = z.object({
  version: z.literal(VERSION_1_0),
  wallets: z.array(
    z.object({
      wallet: z.string().regex(ethereumAddressRegex, "Invalid Ethereum address"),
      amount: z.string().regex(/^(?!,$)[\d,.]+$/, "Amount must be a valid number"),
      currency: z.string().min(1, "Currency cannot be empty")
    })
  ).min(1, "At least one wallet object is required")
});
var defiPassContentSchema = z.union([coverWalletAddressSchema, coverDesignatedWalletsSchema]);
var stakingPoolDetailsSchema = z.object({
  version: z.literal(VERSION_1_0),
  poolName: z.string().min(1, "Pool name cannot be empty"),
  poolDescription: z.string().min(1, "Pool description cannot be empty")
});
var claimProofSchema = z.object({
  // mandatory fields
  version: z.literal(VERSION_1_0),
  coverId: z.number().int().positive(),
  affectedChain: z.string().min(1, "Affected chain cannot be empty"),
  affectedAddresses: z.array(z.string().regex(ethereumAddressRegex, "Invalid Ethereum address")).min(1, "At least one affected address is required"),
  incidentDescription: z.string().min(1, "Incident description cannot be empty"),
  // optional fields
  incidentTransactionHashes: z.array(z.string().min(1, "Transaction hash cannot be an empty string")).min(1, "At least one transaction hash is required").optional(),
  incidentEvidenceLinks: z.array(z.string().url().min(1, "Evidence link cannot be an empty string")).min(1, "At least one evidence link is required").optional(),
  attachedFilesHashes: z.array(z.string().min(1, "Attached file hash cannot be an empty string")).min(1, "At least one attached file hash is required").optional()
});
var assessmentCriteriaAnswersSchema = z.object({
  version: z.literal(VERSION_1_0),
  answers: z.record(z.string()).refine((obj) => Object.keys(obj).length > 0, "Answers object cannot be empty")
});
var governanceProposalSchema = z.object({
  version: z.literal(VERSION_1_0),
  proposal: z.string().min(1, "Proposal cannot be empty")
});
var governanceCategorySchema = z.object({
  version: z.literal(VERSION_1_0),
  category: z.string().min(1, "Category cannot be empty")
});

// src/types/ipfs.ts
var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["coverValidators"] = "coverValidators";
  ContentType2["coverQuotaShare"] = "coverQuotaShare";
  ContentType2["coverAumCoverAmountPercentage"] = "coverAumCoverAmountPercentage";
  ContentType2["coverWalletAddress"] = "coverWalletAddress";
  ContentType2["coverWalletAddresses"] = "coverWalletAddresses";
  ContentType2["coverFreeText"] = "coverFreeText";
  ContentType2["coverDesignatedWallets"] = "coverDesignatedWallets";
  ContentType2["defiPassContent"] = "defiPassContent";
  ContentType2["stakingPoolDetails"] = "stakingPoolDetails";
  ContentType2["claimProof"] = "claimProof";
  ContentType2["assessmentCriteriaAnswers"] = "assessmentCriteriaAnswers";
  ContentType2["governanceProposal"] = "governanceProposal";
  ContentType2["governanceCategory"] = "governanceCategory";
  return ContentType2;
})(ContentType || {});
var IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE = {
  [6 /* ethSlashing */]: "coverValidators" /* coverValidators */,
  [5 /* liquidCollectiveEthStaking */]: "coverValidators" /* coverValidators */,
  [4 /* stakewiseEthStaking */]: "coverValidators" /* coverValidators */,
  [7 /* sherlockQuotaShare */]: "coverQuotaShare" /* coverQuotaShare */,
  [10 /* unoReQuotaShare */]: "coverQuotaShare" /* coverQuotaShare */,
  [16 /* deFiPass */]: "defiPassContent" /* defiPassContent */,
  [19 /* nexusMutual */]: "coverWalletAddresses" /* coverWalletAddresses */,
  [17 /* followOn */]: "coverFreeText" /* coverFreeText */,
  [14 /* fundPortfolio */]: "coverAumCoverAmountPercentage" /* coverAumCoverAmountPercentage */,
  [20 /* generalisedFundPortfolio */]: "coverAumCoverAmountPercentage" /* coverAumCoverAmountPercentage */,
  // ---------------------------------------------------------
  [0 /* protocol */]: void 0,
  [1 /* custody */]: void 0,
  [2 /* yieldToken */]: void 0,
  [3 /* sherlockExcess */]: void 0,
  [8 /* nativeProtocol */]: void 0,
  [9 /* theRetailMutual */]: void 0,
  [11 /* bundledProtocol */]: void 0,
  [12 /* ethSlashingUmbrella */]: void 0,
  [13 /* openCoverTransaction */]: void 0,
  [15 /* sherlockBugBounty */]: void 0,
  [18 /* immunefiBugBounty */]: void 0,
  [21 /* crypto */]: void 0,
  [22 /* nativeSyndicate */]: void 0,
  [23 /* spearbitCantina */]: void 0
};

// src/ipfs/validateIPFSContent.ts
var validateIPFSContent = (type, content) => {
  if (!content) {
    throw new Error("Content cannot be empty");
  }
  switch (type) {
    case "coverValidators" /* coverValidators */:
      return coverValidatorsSchema.parse(content);
    case "coverQuotaShare" /* coverQuotaShare */:
      return coverQuotaShareSchema.parse(content);
    case "coverAumCoverAmountPercentage" /* coverAumCoverAmountPercentage */:
      return coverAumCoverAmountPercentageSchema.parse(content);
    case "coverWalletAddress" /* coverWalletAddress */:
      return coverWalletAddressSchema.parse(content);
    case "coverWalletAddresses" /* coverWalletAddresses */:
      return coverWalletAddressesSchema.parse(content);
    case "coverFreeText" /* coverFreeText */:
      return coverFreeTextSchema.parse(content);
    case "coverDesignatedWallets" /* coverDesignatedWallets */:
      return coverDesignatedWalletsSchema.parse(content);
    case "defiPassContent" /* defiPassContent */:
      return defiPassContentSchema.parse(content);
    case "stakingPoolDetails" /* stakingPoolDetails */:
      return stakingPoolDetailsSchema.parse(content);
    case "claimProof" /* claimProof */:
      return claimProofSchema.parse(content);
    case "assessmentCriteriaAnswers" /* assessmentCriteriaAnswers */:
      return assessmentCriteriaAnswersSchema.parse(content);
    case "governanceProposal" /* governanceProposal */:
      return governanceProposalSchema.parse(content);
    case "governanceCategory" /* governanceCategory */:
      return governanceCategorySchema.parse(content);
    default:
      throw new Error(`Invalid content type: ${type}`);
  }
};

// generated/version.json
var version = "0.18.0";

// src/ipfs/uploadIPFSContent.ts
var uploadToIPFS = async (nexusApiUrl, [type, content]) => {
  if (!nexusApiUrl) {
    throw new Error("IPFS base URL not set");
  }
  const ipfsUploadUrl = nexusApiUrl + `/ipfs?sdk=${version}`;
  try {
    const { data } = await axios.post(ipfsUploadUrl, { type, content });
    return data.ipfsHash;
  } catch (error) {
    console.error("Error:", error);
    throw new Error("Failed to upload data to IPFS");
  }
};
var uploadIPFSContent = (ipfsTypeContentTuple, nexusApiUrl = "https://api.nexusmutual.io/v2") => {
  const [type, content] = ipfsTypeContentTuple;
  if (!content) {
    throw new Error("Content cannot be empty");
  }
  validateIPFSContent(type, content);
  return uploadToIPFS(nexusApiUrl, ipfsTypeContentTuple);
};

// src/ipfs/validateIPFSCid.ts
import isIPFS from "is-ipfs";
var validateIPFSCid = (ipfsCid) => {
  return isIPFS.cid(ipfsCid);
};

// src/quote/index.ts
var quote_exports = {};
__export(quote_exports, {
  getQuoteAndBuyCoverInputs: () => getQuoteAndBuyCoverInputs,
  productsMap: () => productsMap
});

// src/quote/getQuoteAndBuyCoverInputs.ts
import axios2 from "axios";

// generated/product-types.json
var product_types_default = [
  {
    id: 0,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmdunFJm4A5CUW1ynM7bevsGt6UzQfw6K4ysKqvsqpjWCQ",
    name: "Protocol",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 1,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmYhCNjfrNTMq8eyg8i7LbBpTkMCHfix9Sv1jrPb7dYZKd",
    name: "Custody",
    gracePeriod: 10368e3,
    claimMethod: 0
  },
  {
    id: 2,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmcPdiLNZmBM8pjQcCzLhH8tjPuhphCVKZeP5P4SBiLx3h",
    name: "Yield Token",
    gracePeriod: 0,
    claimMethod: 1
  },
  {
    id: 3,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmUTUfdfuZUjtPAiMZ4YRu77SaiyCov7jrSXTgeGeK8qt3",
    name: "Sherlock Excess",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 4,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmPmwtwbyKnXBae1dmYD6jmgnewCeZGPMFGepkWMLWaiwC",
    name: "Stakewise ETH Staking",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 5,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmUKhLi5ZahnzSxsMC9YQZbwwAKGhkHcoYqHUVgE31cXLe",
    name: "Liquid Collective ETH Staking",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 6,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmWepFbtMYSzJt22ddF1CK9PwbrYgiLk9qJjryDrgpGuus",
    name: "ETH Slashing",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 7,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmQfYgbBhyC3gJMvan9gbzUaZtd4Xy4gubEYfgTFKycBDZ",
    name: "Sherlock Quota Share",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 8,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmRrKXV9RBNAB5E1ZEigWmvvT24FgrWNSZ8Yw1VNXR8E6Q",
    name: "Native Protocol",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 9,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmR2s8xo82EUVwRiivBLZEUxmom2sMiHQkNNtu2aNxd2AG",
    name: "The Retail Mutual",
    gracePeriod: 3672e4,
    claimMethod: 0
  },
  {
    id: 10,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmWXYjBYjdKoRw6kyUvp5gYKjj2ojPPVxNYKr1gDjMLssY",
    name: "UnoRe Quota Share",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 11,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmWV9woyKJirjHd73MhibV59qmqzp1w1gqfMfZBQhneSL8",
    name: "Bundled Protocol Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 12,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmQx2H9A51SARNc4W8Ta2D2woXv2ebkUGZMC5HZoQW8TUX",
    name: "ETH Slashing Umbrella",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 13,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmWRir4JSeSv3oKbHyDRz1xFKXh1d8wgew5Rr4koCMeYYu",
    name: "OpenCover Transaction",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 14,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmevgAXtzi7773NaBrzGyW95aKSrt3MBtpQU1SQCPyCbSF",
    name: "Fund Portfolio Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 15,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/Qmbs7GPhxeYC5Y2xZX5ZGcsnUxz68XdFbfTknHFXpnGRh5",
    name: "Sherlock Bug Bounty",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 16,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmQLh2wNDD2b2RGg9rNFbyrQwxqTthrTNaTsHenZnRg6u6",
    name: "DeFi Pass",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 17,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmYgZNrGSAQZCGKEGdgvR132KWkLKtSDXmZVGfoGSKfYMG",
    name: "Follow On Cover",
    gracePeriod: 864e4,
    claimMethod: 0
  },
  {
    id: 18,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmRzT2MF4aWQs2UJZBTHU8gFnPsEGQWRQ75zwQP4dh514Y",
    name: "Immunefi Bug Bounty Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 19,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmYdBBwtdn9Z6j9nX3SkzPjWmvHxjMUbu44sibnQ9QrCHX",
    name: "Nexus Mutual Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 20,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmPwYKc8WQYmTeq5cZ7wxPbZfgTHm9aHh7SLAHpf4g1yQi",
    name: "Generalised Fund Portfolio Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 21,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/Qmas9sr9BA9DmdgbHpyTmYUwvv2Kxyc1upDEarEerti2hs",
    name: "Crypto Cover",
    gracePeriod: 10368e3,
    claimMethod: 0
  },
  {
    id: 22,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmUzkWmZhEr9i8eMxPpoz59aZRxZ4uVSbjkD8EnAxrX3VP",
    name: "Native Syndicate Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  },
  {
    id: 23,
    coverWordingURL: "https://api.nexusmutual.io/ipfs/QmR8jRGHA3fsLnBK5dtj27evTDQ3Vyic3zJnCh7dVas3pL",
    name: "Spearbit Cantina Cover",
    gracePeriod: 3024e3,
    claimMethod: 0
  }
];

// generated/products.json
var products_default = [
  {
    id: 0,
    name: "0x v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "zerox.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 1,
    name: "1Inch",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "oneinch.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 2,
    name: "Aave v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "aavev2.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 3,
    name: "Abracadabra v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "abracadabra.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 4,
    name: "Alchemix v2",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "alchemix.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 5,
    name: "Anchor",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "anchor.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 6,
    name: "Angle v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "angle.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 7,
    name: "Argent",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "argent.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 8,
    name: "Aura v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "aura.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 9,
    name: "Babylon Finance",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "babylon.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 10,
    name: "BadgerDAO v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "badgerdao.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 11,
    name: "Balancer v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "balancer.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 12,
    name: "Bancor v2",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "bancor.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 13,
    name: "Bancor v3",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "bancor.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Liquidity provider (LP) losses as a result of previously disclosed design issues, which include but is not limited to accumulated LP losses due to BNT pairs without IL protection"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 14,
    name: "Beefy v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "beefy.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 15,
    name: "Binance",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "binance.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 16,
    name: "BlockFi",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "blockFi.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 17,
    name: "Bundle: Gelt + mStable + Aave v2",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "gelt.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 18,
    name: "Centrifuge Tinlake",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "centrifuge.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 19,
    name: "Coinbase",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "coinbase.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 20,
    name: "Compound v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "compoundv2.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 21,
    name: "Convex 3CRV (cvx3CRV)",
    productType: 2,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "convex.svg",
    metadata: {},
    coverAssets: [
      "DAI"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 0
  },
  {
    id: 22,
    name: "Convex Finance v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "convex.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 23,
    name: "Convex stethCrv (cvxstethCrv)",
    productType: 2,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "convex.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 0
  },
  {
    id: 24,
    name: "Crypto.com",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "crypto-com.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 100
  },
  {
    id: 25,
    name: "Curve 3pool LP (3Crv)",
    productType: 2,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "curve.svg",
    metadata: {},
    coverAssets: [
      "DAI"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 0
  },
  {
    id: 26,
    name: "Curve All Pools (incl staking)",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "curve.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 40
  },
  {
    id: 27,
    name: "Curve sETH LP (eCrv)",
    productType: 2,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "curve.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1678392947,
    minPrice: 0
  },
  {
    id: 28,
    name: "dydx v3 (EVM)",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "dydx.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 29,
    name: "Ease v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "ease.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 30,
    name: "Enzyme v3",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "enzyme.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 31,
    name: "Enzyme v4",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "enzyme.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 32,
    name: "Eth 2.0 (deposit contract)",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eth.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 33,
    name: "Euler",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "euler.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 34,
    name: "FODL v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "fodl.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 35,
    name: "FTX",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "ftx.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 36,
    name: "Gearbox v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "gearbox.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 37,
    name: "Gemini",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "gemini.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 38,
    name: "GMX v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "gmx.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Liquidity provider (LP) losses as a result of previously disclosed design issues, which include but is not limited to [accumulated LP losses due to zero-slippage design](https://www.coindesk.com/markets/2022/09/19/defi-trader-nets-over-500k-by-using-dex-gmx-to-manipulate-avalanche-token/)",
        ""
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 39,
    name: "Goldfinch v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "goldfinch.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 40,
    name: "Hodlnaut",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "hodlnaut.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 41,
    name: "Kraken",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "kraken.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 42,
    name: "Ledn",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "ledn.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 43,
    name: "Liquid Collective",
    productType: 5,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "liquidcollective.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 44,
    name: "Liquity v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "liquity.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 45,
    name: "Sky Protocol",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "sky-money.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 60
  },
  {
    id: 46,
    name: "mStable",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "mstable.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 47,
    name: "Nested v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "nested.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 48,
    name: "Nexo",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "nexo.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 49,
    name: "Notional Finance v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "notional-finance.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 50,
    name: "OlympusDAO",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "olympusdao.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 51,
    name: "Opyn v2",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "opyn.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 52,
    name: "Origin OUSD",
    productType: 2,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "originusd.svg",
    metadata: {},
    coverAssets: [
      "DAI"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 0
  },
  {
    id: 53,
    name: "Pangolin v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "pangolin.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 54,
    name: "Perpetual Protocol v2",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "perpetual.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 55,
    name: "Pool Together v4",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "pooltogether.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 56,
    name: "Premia Finance",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "premia.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 57,
    name: "Rari Capital",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "rari.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 58,
    name: "Reflexer v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "reflexer.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 59,
    name: "Aevo",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "ribbon.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393031,
    minPrice: 100
  },
  {
    id: 60,
    name: "Safe",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "gnosis-safe.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 61,
    name: "Set Protocol",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "tokensets.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 62,
    name: "Set Protocol v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "tokensets.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 63,
    name: "Sherlock",
    productType: 4,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "sherlock.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 64,
    name: "Stake DAO v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "stakedao.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 65,
    name: "Stakewise 3rd party (3 ETH/validator)",
    productType: 3,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "stakewise.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 66,
    name: "Stakewise operated (3 ETH/validator)",
    productType: 3,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "stakewise.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 67,
    name: "SushiSwap v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "sushiswap.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 68,
    name: "Synthetix",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "synthetix.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 69,
    name: "THORChain (Thorchain Network)",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "thorchain.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 70,
    name: "LFJ",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "lfj.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1740672395,
    minPrice: 100
  },
  {
    id: 71,
    name: "Uniswap v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "uniswapv2.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 72,
    name: "Uniswap v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "uniswapv2.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 73,
    name: "Vector v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "vector.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 74,
    name: "Vesper v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "vesper.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 75,
    name: "Yearn Finance v2 (all vaults)",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "yearn.svg",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 76,
    name: "Yearn yvUSDC v2",
    productType: 2,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "yearn.svg",
    metadata: {},
    coverAssets: [
      "DAI"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 0
  },
  {
    id: 77,
    name: "Yeti Finance v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "yeti.png",
    metadata: {
      exclusions: [
        "Losses due to a compromised wallet",
        "Losses due to a previously disclosed vulnerability",
        "Losses that occur outside the designated protocol, such as a separate protocol used in an underlying yield aggregation strategy"
      ]
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 78,
    name: "Yield App",
    productType: 1,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "yield-app.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1678393127,
    minPrice: 100
  },
  {
    id: 79,
    name: "Alpaca Finance v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "alpaca.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 80,
    name: "WeFi v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "wefi.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 81,
    name: "Exactly",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "exactly.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1682080307,
    minPrice: 100
  },
  {
    id: 82,
    name: "EtherFi 5ETH",
    productType: 6,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "etherfi.svg",
    metadata: {
      schedule: "QmNLoufTxAfmAsZfFPas2QJvgwmLVsY4mGyn9VK6cpF2e3"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 83,
    name: "Squeeth by Opyn (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "squeeth-by-opyn.png",
    metadata: {
      annex: "QmSBvXTyDrrhQZir1CAwfZY7dYysMdMznMqv753LDS2uix"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 84,
    name: "Rage Trade (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "rage-trade.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 85,
    name: "Sentiment (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "sentiment.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 86,
    name: "Lyra Newport (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "lyra.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 87,
    name: "Perennial (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "perennial.jpeg",
    metadata: {
      annex: "QmRMnVaZvAJQUTFF4PReXTeHv6vrQJvTz3T9UpuARf2djR"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 88,
    name: "LiquiFi (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "liquify.svg",
    metadata: {
      annex: "QmSZ8pTHUGE4HjCSbG5DvyvM4axYKwcUwQ3nbdHrKLdU3b"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1704981731,
    minPrice: 100
  },
  {
    id: 89,
    name: "Lyra Avalon (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "lyra.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 90,
    name: "Buffer Finance (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "buffer-finance.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 91,
    name: "Hook (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "hook.jpeg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 92,
    name: "Holyheld (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "holyheld.jpeg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 93,
    name: "Union Finance (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "union-finance.svg",
    metadata: {
      annex: "QmbG3HRdbNJKeoRp8ScKrYUtiZpfqfWKSmWuYu3mN4LutK"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 94,
    name: "OpenQ (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "openq.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1684312727,
    minPrice: 100
  },
  {
    id: 95,
    name: "Level Finance v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "level-finance.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1686061307,
    minPrice: 100
  },
  {
    id: 96,
    name: "Offramp.xyz v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "offramp.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 97,
    name: "Aave v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "aavev3.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1686061307,
    minPrice: 100
  },
  {
    id: 98,
    name: "Morpho Optimisers v1",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "morpho.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 99,
    name: "Chorus One",
    productType: 6,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "chorusone.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 100,
    name: "Kiln",
    productType: 6,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "kiln.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 101,
    name: "Vertex (Native Protocol)",
    productType: 8,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "vertex.svg",
    metadata: {
      schedule: "QmX4HnfD4RToyBNSLocCqSxHcSzWBUDHDGxAtTvR2gsBmy"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 102,
    name: "The Retail Mutual",
    productType: 9,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "the-retail-mutual.png",
    metadata: {},
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1688467835,
    minPrice: 100
  },
  {
    id: 103,
    name: "Figment",
    productType: 6,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "figment.svg",
    metadata: {
      schedule: "QmaXutduGRq4gpZ7xKUHQeAHd67X8zMXuzXVTncxx2kJqk"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 104,
    name: "Teller (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "teller.svg",
    metadata: {
      annex: "QmUeLxx2o32gGJd9yQ3V1So35TGhYrt6QrpoCvGsrZPeMY"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1689782903,
    minPrice: 100
  },
  {
    id: 105,
    name: "Ajna (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "ajna.svg",
    metadata: {
      annex: "QmSqCe8QrPSCjAXRrWxcqFLnFvK4Eecw8NZ6hYEFAgQVyD"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1689782903,
    minPrice: 100
  },
  {
    id: 106,
    name: "EigenLayer v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "eigenlayer.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1690296191,
    minPrice: 100
  },
  {
    id: 107,
    name: "Vox Finance (UnoRe)",
    productType: 10,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "vox.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 108,
    name: "MahaLend (UnoRe)",
    productType: 10,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "mahalend.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 109,
    name: "SELF (UnoRe)",
    productType: 10,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "self.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 110,
    name: "Scallop (UnoRe)",
    productType: 10,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "scallop.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 111,
    name: "WeFi (UnoRe)",
    productType: 10,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "wefi.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 112,
    name: "ZkTsunami (UnoRe)",
    productType: 10,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "zktsunami.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 113,
    name: "Hats Protocol",
    productType: 8,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "hats.svg",
    metadata: {
      schedule: "QmQMLsH7rs4WoNkvdLSCmhHcAHynbHtHzPsPRY3SFdd98D"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 114,
    name: "DAI Savings Rate (sDAI)",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "sdai.svg",
    metadata: {},
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 115,
    name: "Spark Lending v1",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "spark-lending.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1693212491,
    minPrice: 100
  },
  {
    id: 116,
    name: "DefiEdge",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "defi-edge.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1694434295,
    minPrice: 100
  },
  {
    id: 117,
    name: "Stakewise v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "stakewisev3.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1701270695,
    minPrice: 100
  },
  {
    id: 118,
    name: "Compound v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "compoundv3.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 119,
    name: "Product Removed",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "deprecated.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1704981563,
    minPrice: 100
  },
  {
    id: 120,
    name: "Product Removed",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "deprecated.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1704981563,
    minPrice: 100
  },
  {
    id: 121,
    name: "Product Removed",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "deprecated.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1704981563,
    minPrice: 100
  },
  {
    id: 122,
    name: "Product Removed",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "deprecated.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1704981563,
    minPrice: 100
  },
  {
    id: 123,
    name: "Yearn v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "yearn.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1705077767,
    minPrice: 100
  },
  {
    id: 124,
    name: "Velodrome",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "velodrome.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1740672395,
    minPrice: 100
  },
  {
    id: 125,
    name: "GMX v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "gmxv2.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1705077767,
    minPrice: 100
  },
  {
    id: 126,
    name: "dHEDGE",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "dhedge.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1705077767,
    minPrice: 100
  },
  {
    id: 127,
    name: "Term Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "term-finance.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1706089043,
    minPrice: 100
  },
  {
    id: 128,
    name: "Pendle",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "pendle.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1706089043,
    minPrice: 100
  },
  {
    id: 129,
    name: "Aerodrome",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "aerodrome.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1706089043,
    minPrice: 100
  },
  {
    id: 130,
    name: "Hyperliquid",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "hyperliquid.svg",
    metadata: {
      annex: "QmZYgda3f3CBbV7TRBViiMqc9cNRZ8Ud3bsTUMFnRD1arb"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1742481059,
    minPrice: 100
  },
  {
    id: 131,
    name: "Maverick",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "maverick.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1706624999,
    minPrice: 100
  },
  {
    id: 132,
    name: "Equilibria",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "equilibria.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1708086935,
    minPrice: 100
  },
  {
    id: 133,
    name: "Camelot",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "camelot.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1708944959,
    minPrice: 100
  },
  {
    id: 134,
    name: "NFTperp",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "nftperp.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 135,
    name: "Gearbox v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "gearbox.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1708944959,
    minPrice: 100
  },
  {
    id: 136,
    name: "pxETH",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "pxeth.svg",
    metadata: {
      annex: "QmfHGfWr3tYxD1SvCphAXLN5X6QDP4evFXPrZaRYJZWWPw"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1709311739,
    minPrice: 100
  },
  {
    id: 137,
    name: "fx Protocol",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "fx-protocol.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1709806439,
    minPrice: 100
  },
  {
    id: 138,
    name: "Prisma",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "prisma.svg",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 139,
    name: "Beethoven X",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "beethovenx.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1709806439,
    minPrice: 100
  },
  {
    id: 140,
    name: "Arrakis",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "arrakis.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1709806439,
    minPrice: 100
  },
  {
    id: 141,
    name: "Yearn v3",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "yearn-v3.svg",
    metadata: {
      annex: "QmWZKk6ZUawwkCjo3yQcKP7tjDnq2MvUfZLpNAee92Chpg"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 142,
    name: "Synthetix Ecosystem",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "synthetix-ecosystem.svg",
    metadata: {
      annex: "QmTJjAw37hUNPdUG6JsEModzXnsmQEriLV27RWGEqc3zAa"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 143,
    name: "EigenLayer + Ether.fi + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eigenlayer-etherfi-pendle.svg",
    metadata: {
      annex: "QmcmePeAwHQgKLpdAYvwxAUMcNydSYPgMfBrc74ikCrcL5"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 144,
    name: "Beefy + Curve",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-curve.svg",
    metadata: {
      annex: "QmWDscKiAdqZmX8HrigviLbLtnXniCjm6jdE1PMe2ngaMS"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 145,
    name: "Beefy + Compound v3",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-compoundv3.svg",
    metadata: {
      annex: "QmeYyMMkDf2bE5vC4mfhye3aZvXdsxJ3KXW4TEdkWdTidg"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 146,
    name: "Beefy + Balancer v2 + Aura",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-balancerv2-aura.svg",
    metadata: {
      annex: "QmaWqjvjMdBPBkqEUrbK6juCxGtsR6ZcPgcN4pUyX8ftE3"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 147,
    name: "Notional v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "notional-finance.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1710517631,
    minPrice: 100
  },
  {
    id: 148,
    name: "Fraxlend",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "fraxlend.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1710517631,
    minPrice: 100
  },
  {
    id: 149,
    name: "wstETH/USDC Market Morpho Blue",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "morpho.svg",
    metadata: {
      annex: "QmYYZGmdgrPqUe1d1cwB9NPQbJVCFVEiLvonUgViLyViqA"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 150,
    name: "Ether.fi Liquid ETH Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi.svg",
    metadata: {
      annex: "QmWrJezQjY1oi9UviRLtbW4MfbeHNtQHQKEbn9Noh8N3ZP"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1723127459,
    minPrice: 100
  },
  {
    id: 151,
    name: "Arcadia (Sherlock)",
    productType: 7,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "arcadia.svg",
    metadata: {
      annex: "QmeLHGmDfEyUZyUKxcGaWnZtJAcvqMp1SBB9Qz2YAZfkAe"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1711473767,
    minPrice: 100
  },
  {
    id: 152,
    name: "fx Protocol",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "fx-protocol.svg",
    metadata: {
      annex: "QmR438ccaJav8MhDWwx3mhcqMbmaucsAa7b7bdrsiQwJBd"
    },
    coverAssets: [
      "ETH",
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 153,
    name: "EigenLayer + KelpDAO + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eigenlayer-kelp-pendle.svg",
    metadata: {
      annex: "QmPeGsJEP9nDV7DBHpXPZGd9FXFy5XR7Wd8Z7L5bCMhosv"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 154,
    name: "EigenLayer + Renzo + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eigenlayer-renzo-pendle.svg",
    metadata: {
      annex: "QmPXPEAZ4hsLBdbpcMhEiKBwUANqohE7BSscvtZ7b4amx3"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 155,
    name: "EigenLayer + Swell + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eigenlayer-swell-pendle.svg",
    metadata: {
      annex: "QmTLMiq9wB39Z5Z7VK5sAKfkdEuGM4KXUWpqWu5Nn9ZoHT"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 156,
    name: "Arcadia",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "arcadia.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1712244083,
    minPrice: 100
  },
  {
    id: 157,
    name: "Derive (formerly Lyra)",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "derive.svg",
    metadata: {
      annex: "QmYwhuvn9fT6RBYWbgPaECE8cDMt87JcUumqUhYLvR27Ue"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1733753135,
    minPrice: 100
  },
  {
    id: 158,
    name: "Renzo",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "renzo.png",
    metadata: {
      annex: "QmeC8wJDjb92Ni8P82hkqPu1vT2mTFDUopveG73n4rgAGh"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 159,
    name: "Liquid Collective",
    productType: 12,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "liquidcollective.svg",
    metadata: {
      annex: "QmZ4XB78eFzfcAReQHVdzPrab9m9JNtJ2QkLA6qsDSCoRZ"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1712739011,
    minPrice: 100
  },
  {
    id: 160,
    name: "Etherfi (Zircuit) Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "etherfi-zircuit-pendle.svg",
    metadata: {
      annex: "QmdUDjxeoAHmjydTnUmU2VPerzoRXpo8c7NjGjmbmC9AEV"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 161,
    name: "KelpDAO (Zircuit) Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "kelpdao-zircuit-pendle.svg",
    metadata: {
      annex: "QmUD3G8kqMdJ32CspFPjJgRXunh6KfBb1NRWtyVBvSLhe7"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 162,
    name: "Renzo (Zircuit) Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "renzo-zircuit-pendle.svg",
    metadata: {
      annex: "QmYKyLc7eMjbXEXMTvPcEidZoTKC7e6G2pJANkZ84QHJpr"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 163,
    name: "Pocket Universe",
    productType: 13,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "pocket-universe.png",
    metadata: {
      annex: "Qmdraw2ecUyPQJAoMQsTFEpCfL27S3KVqZKHxxPLwkNqoQ"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1713884351,
    minPrice: 100
  },
  {
    id: 164,
    name: "Request Finance",
    productType: 13,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "request-finance.svg",
    metadata: {
      annex: "QmZ55Zat2quranHnQEoWiBqsuYHvnABFFz1qxmoR5Q2kAN"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1736430671,
    minPrice: 100
  },
  {
    id: 165,
    name: "Ether.fi Liquid Market-Neutral USD Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi.svg",
    metadata: {
      annex: "QmQ6J9CebxrU4fMqjT6RgfH76uRRJwgFy34auoCtj2NfJR"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 166,
    name: "Superform",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "superform.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1715349875,
    minPrice: 100
  },
  {
    id: 167,
    name: "Ether.fi",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi.svg",
    metadata: {
      annex: "QmSsogSnNxfa7Xf2QMtwww914Xy5RscdX21yK25kMnw6pY"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 168,
    name: "Beefy CLM + Uniswap v3",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-uniswap.svg",
    metadata: {
      annex: "QmfZerropFXnEeZCG2kEyNvqRMW8dn6UvDnNB8JPBTozF8"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 169,
    name: "RockX",
    productType: 6,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "rockX.png",
    metadata: {
      schedule: "QmRQVYLhC1QpB32g5UZbHPK5kot6oqXVYnr4CG1oYajsmt"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 170,
    name: "sUSDe Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "sUSDe-pendle.svg",
    metadata: {
      annex: "QmRHJyKquZa4X2NUyM2BXJYncoUTtb622Uj2kdZRwv32AV"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 171,
    name: "sUSDe (Karak) Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "sUSDe-karak-pendle.svg",
    metadata: {
      annex: "QmcHcE2iqsjFEotqQqutzkPBSSem8hq5FsFeYQJoo3Mg6s"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 172,
    name: "Steakhouse MetaMorpho + Morpho Blue",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "steakhouse-morpho.svg",
    metadata: {
      annex: "QmbzaCUxudd2amjUuyHgQeD7cioykH5CxeWhQi9dSMwqiS"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 173,
    name: "Re7 MetaMorpho + Morpho Blue",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "re7-morpho.svg",
    metadata: {
      annex: "QmZh3sXy94wVxy8RBpnJwJ382AK8mScbXjSBcNWMUjdcin"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 174,
    name: "Index Coop",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "index-coop.svg",
    metadata: {
      annex: "QmeJpztYL4hFyt5LTmLMptrd1P7dRszSELtxLnwKTvubCt"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1717761119,
    minPrice: 100
  },
  {
    id: 175,
    name: "Gauntlet MetaMorpho + Morpho Blue",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "gauntlet-morpho.svg",
    metadata: {
      annex: "QmayjJ1JCcrMc8Gc39wURyi37Bba3EfJHCK8or2Ce4JKE1"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 176,
    name: "Ether.fi (Karak) Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "etherfi-karak-pendle.svg",
    metadata: {
      annex: "QmPgxu3Q3TF3Rbt8R3hVNuVodfyUSXUEStQdwgd9gKhWvs"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 177,
    name: "EigenLayer + Puffer + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eigenlayer-puffer-pendle.svg",
    metadata: {
      annex: "QmUzQ87q5BQgpmpjWeEuHHA6pnmCcwg5H5NB1nrPqfTFmC"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 178,
    name: "EigenLayer + Bedrock + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "eigenlayer-bedrock-pendle.svg",
    metadata: {
      annex: "QmQp25a2nBWLG8DCzFkXyxtVppdB8RkqRaDo7Qkdtuxvre"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 179,
    name: "crvUSD (Silo) Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "crvUSD-silo-pendle.svg",
    metadata: {
      annex: "QmeZZcPqe13kCrUM7JaPgcs7Ce1A8Z5c7fqBhzqC32en7z"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 180,
    name: "Block Analitica/B.Protocol MetaMorpho + Morpho Blue",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "block-analitica-morpho.svg",
    metadata: {
      annex: "Qmc8C1unECSJFfiBBwp4UK3R3j5F6B9HyUKyZvwraV5i5x"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 181,
    name: "Beefy + Aerodrome",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-aerodrome.svg",
    metadata: {
      annex: "QmcAEaLNCZjW7T35xntxkdWo8Fxg2r2V7Va8cs9Crj2Mfh"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 182,
    name: "ExtraFi",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "extrafi.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1717761119,
    minPrice: 100
  },
  {
    id: 183,
    name: "Moonwell",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "moonwell.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1717761119,
    minPrice: 100
  },
  {
    id: 184,
    name: "Instadapp Fluid",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "instadapp-fluid.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1717761119,
    minPrice: 100
  },
  {
    id: 185,
    name: "Silo Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "silo-finance.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1717761119,
    minPrice: 100
  },
  {
    id: 186,
    name: "DeltaPrime (UnoRe)",
    productType: 8,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "delta-prime.svg",
    metadata: {
      schedule: "QmQiE8jbvrQXsnjaasrX7NmkDihnYUuKdKmqKDvYfucgCi"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 187,
    name: "Toros Finance Solana Bull 3x",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "toros-solona.png",
    metadata: {
      annex: "QmegxMAL7QJ9n4FWUu3xmtQbvEkTRp8WjANVEHd2PXmYBC"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 188,
    name: "Toros Finance Ethereum Bull 3x",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "toros-ethereum.png",
    metadata: {
      schedule: "QmRCQ82oqnhtWwNWLmiWjjjGxQVKpD9P2yJaeXVeBUDWXd"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 189,
    name: "Toros Finance",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "toros-finance.svg",
    metadata: {
      annex: "Qmd6QaZY9K3cMnn63xm5GEGWZhvKbJLcCcxV8g7Z44syHx"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 190,
    name: "Notional v3",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "notional-finance.svg",
    metadata: {
      annex: "QmYmuSmicQRYtsoBmuEu1JAUApGdKRJqxY5uooKzTg7mfr"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 191,
    name: "Overnight Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "overnight.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1718295167,
    minPrice: 100
  },
  {
    id: 192,
    name: "Symbiotic",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "symbiotic.png",
    metadata: {},
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1718295167,
    minPrice: 100
  },
  {
    id: 193,
    name: "Ether.fi Liquid Super Symbiotic LRT Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi.svg",
    metadata: {
      annex: "QmWiSWsicYttwu7vxbEu3p5YTW1n9RS7nsBcBCB9hz7gsi"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 194,
    name: "Toros Finance Andromeda Yield",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "toros.png",
    metadata: {
      annex: "QmPKt54Hj1saZ997qizyM8iJQQechkMhUF81SAkLVRvtqS"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 195,
    name: "Dialectic Moonphase",
    productType: 14,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "dialectic-moonphase.svg",
    metadata: {
      annex: "Qmd6Mb1bPR4bTgrH5WX8ZHj6ViRssduBJHYiduogmgzUgx"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1719493331,
    minPrice: 100
  },
  {
    id: 196,
    name: "Dialectic Chronograph",
    productType: 14,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "dialectic-chronograph.svg",
    metadata: {
      annex: "QmWsnT3utA3gqXSRdkaLcXNoQKYMASrDrbTv1aGvJ29pXK"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1719493331,
    minPrice: 100
  },
  {
    id: 197,
    name: "Spectra",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "spectra.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1719493331,
    minPrice: 100
  },
  {
    id: 198,
    name: "Origin OUSD",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "origin-ousd.svg",
    metadata: {
      annex: "QmT8Spi995HC3Ae8bxKPzLgFfz4FeuiJkEQZNfTa3tesrP"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 199,
    name: "Mellow (P2P Market) + Symbiotic",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "mellow-p2p-market-symbiotic.svg",
    metadata: {
      annex: "QmcQDhRUmpFBgQJJSq4Ty11X3vWNS1yVZdFg98g9HFiMfL"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 200,
    name: "Mellow",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "mellow.jpg",
    metadata: {
      annex: "QmeaCFqgDEqTwatsyRGjcyhogVSRfAgTuig2E74WSKrWcz"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 201,
    name: "Mellow (Re7 Labs Market) + Symbiotic",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "mellow-re7-labs-market-symbiotic.svg",
    metadata: {
      annex: "QmQmgqM4QsfyNhpHmx2z52nTgH3mRZXzdQ8GQf947j2m4k"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 202,
    name: "Mellow (MEV Capital Market) + Symbiotic",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "mellow-mev-capital-market-symbiotic.svg",
    metadata: {
      annex: "QmPpqLhN1mBp4L7xRJb1Cixnwz5ZvhKDoHXCoZKrySZp2W"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 203,
    name: "rstETH Symbiotic + Mellow + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "rsteth-symbiotic-mellow-pendle.svg",
    metadata: {
      annex: "QmQHrgBDFMcsctniwXQQdE7JoU7Zm92Eyizh6HtpnAkkLa"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 204,
    name: "amphrETH Symbiotic + Mellow + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "amphreth-symbiotic-mellow-pendle.svg",
    metadata: {
      annex: "QmdmjZo6cmoB4amzYdNYWrNmLJ3wAQEPFCHF31LE236821"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 205,
    name: "steakLRT Symbiotic + Mellow + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "steaklrt-symbiotic-mellow-pendle.svg",
    metadata: {
      annex: "QmYCcHXmJa4CQ6jUNSDW1DqHkpTgM8hH1AZ2ZFLKSLfrGz"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 206,
    name: "Re7LRT Symbiotic + Mellow + Pendle",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "re7lrt-symbiotic-mellow-pendle.svg",
    metadata: {
      annex: "QmckCaqQRHb78goFuu7ujFnaU9VzafiGufDGvPEvLjXmHd"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 207,
    name: "Inverse Finance FiRM",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "inverse-finance-firm.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1720101131,
    minPrice: 100
  },
  {
    id: 208,
    name: "Inverse Finance sDOLA",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "inverse-finance-sdola.png",
    metadata: {},
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 50
  },
  {
    id: 209,
    name: "Ether.fi Liquid King Karak LRT Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi-liquid-king-karak-lrt-vault.svg",
    metadata: {
      annex: "QmdVbs1uyJnXLrF8GZfU1czC361g3b4kVJueP8ftA7ERBr"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 210,
    name: "Beefy CLM + Velodrome",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-clm-velodrome.svg",
    metadata: {
      annex: "QmQbSWkfNS7zYXrBnpVmZ23hbfZWZUZH5j8hHCkTgSQ7a1"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 211,
    name: "Beefy",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "beefy.svg",
    metadata: {
      annex: "QmamPEnT8cN6nCZic1t8Nj9a1km1AkhuAgaufTYPcPMEGv"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1744902863,
    minPrice: 100
  },
  {
    id: 212,
    name: "Beefy CLM + Camelot",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-clm-camelot.svg",
    metadata: {
      annex: "QmXUGbJxBBXuPRAP35jx4ZT5rXSVjHj7cgqUEeeUxhHP5N"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 213,
    name: "Beefy CLM + PancakeSwap",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-clm-pancakeswap.svg",
    metadata: {
      annex: "QmchbsYEWzEVTPQNLUBT2yCmR979Fa9E56SKdtBwQdZWRz"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 214,
    name: "Curve LlamaLend",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "curve-llamalend.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1720704119,
    minPrice: 100
  },
  {
    id: 215,
    name: "Ramses Exchange",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "ramses-exchange.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1720704119,
    minPrice: 100
  },
  {
    id: 216,
    name: "Credit Guild",
    productType: 0,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "credit-guild.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 100
  },
  {
    id: 217,
    name: "Reserve",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "reserve.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1721230847,
    minPrice: 100
  },
  {
    id: 218,
    name: "Contango",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "contango.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1721230847,
    minPrice: 100
  },
  {
    id: 219,
    name: "Flat Money (Sherlock)",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "flat-money.svg",
    metadata: {
      annex: "QmSFXJ8EFCtChSyRCJotApPymtuaW1syqAd2c7hCsYcsz8"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1723127459,
    minPrice: 100
  },
  {
    id: 220,
    name: "Flat Money (Sherlock)",
    productType: 15,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "flat-money.svg",
    metadata: {
      annex: "QmSFXJ8EFCtChSyRCJotApPymtuaW1syqAd2c7hCsYcsz8"
    },
    coverAssets: [
      "DAI",
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1723127459,
    minPrice: 100
  },
  {
    id: 221,
    name: "Ether.fi Liquid eBTC Bitcoin LRT",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi-liquid-ebtc-bitcoin-lrt-vault.svg",
    metadata: {
      annex: "QmWGh6zGMdxsCXavGpAvdBwqwdumcueUWsvwbyZH5TDKoz"
    },
    coverAssets: [
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 222,
    name: "Contango + Compound v3",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "contango-compound.svg",
    metadata: {
      annex: "QmfG4ChSpunTXK1xefk3BFnyqKwrNNEdadU6iVCnxVZzAr"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 223,
    name: "Contango + Aave v3",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "contango-aave.svg",
    metadata: {
      annex: "QmPHT5KMQWWJz6Fb95fdBU9DiR1dHFJxcQeBGPeWywSmMS"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 224,
    name: "Contango",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "contango.jpg",
    metadata: {
      annex: "QmdhMG3K8EuCg6amMxjyTPwXjdAjiSa7sHunMsgthepnQt"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 100
  },
  {
    id: 225,
    name: "PancakeSwap",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "pancake-swap.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1725264851,
    minPrice: 100
  },
  {
    id: 226,
    name: "Beefy + Velodrome",
    productType: 11,
    isDeprecated: true,
    useFixedPrice: false,
    logo: "beefy-velodrome.svg",
    metadata: {
      annex: "QmNeuhDq2mbi2oyBCxNc1giLPUfAWHrjJTn1gkmGtbMerm"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 227,
    name: "Base DeFi Pass",
    productType: 16,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "base.svg",
    metadata: {
      annex: "QmfDQKWQHdyQ6XAXbzNoGApMVRjvTJRhpghoqJJ7yRBMsx"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1740672395,
    minPrice: 275
  },
  {
    id: 228,
    name: "Blue Chip Euler v2 Markets",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "blue-chip-euler-v2-markets.svg",
    metadata: {
      annex: "QmRCz3JMCBt14w2sThGu2uJT1cMVRuMphxFbaLavhxDRcE"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 100
  },
  {
    id: 229,
    name: "Blue Chip Morpho Vaults",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "blue-chip-morpho-vaults.svg",
    metadata: {
      annex: "QmTT5q9ny2EhgGSjKczMJ6t4emmagUUtipMwVeBhhhnR9B"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 230,
    name: "Ajna Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "ajna-finance.svg",
    metadata: {
      annex: "QmaQ2P8ZgHMG18VWvh1uBdsuvKM6pKUKPfhArNd3YsQUoL"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 231,
    name: "Dolomite",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "dolomite.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 232,
    name: "Steer Protocol",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "steer-protocol.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726227311,
    minPrice: 100
  },
  {
    id: 233,
    name: "Relative Finance",
    productType: 8,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "relative-finance.svg",
    metadata: {
      annex: "QmdYmtR58p3XYkv4tFuo6REuKCkjFzbGkZP1Pwh2YizaMn"
    },
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1739969915,
    minPrice: 100
  },
  {
    id: 234,
    name: "AO Staking",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "ao-staking.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726758407,
    minPrice: 100
  },
  {
    id: 235,
    name: "GammaSwap",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "gamma-swap.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "DAI",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1726758407,
    minPrice: 100
  },
  {
    id: 236,
    name: "Ether.fi Liquid Usual Stable Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi-liquid-usual-stable-vault.svg",
    metadata: {
      annex: "QmbyNkZDRTedHZQWQ1hYov6hQc57s8JYff8R3SyfusNGKw"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 237,
    name: "Ether.fi Liquid Elixir Stable Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "etherfi-liquid-elixir-stable-vault.svg",
    metadata: {
      annex: "QmXioicc3tS4QmEsonAz9Qrgs7BxPvWRaM42kcdiXytJTz"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 238,
    name: "Sky Savings Rate (sUSDS)",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "sUSDS.svg",
    metadata: {},
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 10
  },
  {
    id: 239,
    name: "Everstake",
    productType: 12,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "everstake.jpg",
    metadata: {
      annex: "QmXsCqhnVmyKAozgjnuHrwEcqqFFiy7nF9S57yt2ALB6CK"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1731583079,
    minPrice: 100
  },
  {
    id: 240,
    name: "Ensuro",
    productType: 17,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "ensuro.svg",
    metadata: {
      annex: "QmS1fJaUyJUgtpsqbX7rc8qoWUWY5X7MXRJU9KucFmFsAx"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1731583079,
    minPrice: 100
  },
  {
    id: 241,
    name: "Savings crvUSD (scrvUSD)",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "scrvusd.svg",
    metadata: {},
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 25
  },
  {
    id: 242,
    name: "Lombard DeFi Vault",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "lombard-finance.svg",
    metadata: {
      annex: "QmWKTG9K6cE7Kxq9mCLdaMTBkHXXqQ1BdzmQdPDohfauDi"
    },
    coverAssets: [
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1734557999,
    minPrice: 100
  },
  {
    id: 243,
    name: "Liquity v2",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "liquity-v2.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1731583079,
    minPrice: 100
  },
  {
    id: 244,
    name: "CoW AMM",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "cow-amm.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1731583079,
    minPrice: 100
  },
  {
    id: 245,
    name: "Entry Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "entry-plan.svg",
    metadata: {
      annex: "QmY7ZEU26f9xHjsCr59wNthyAVDsbGxCCqxaKe5a3ZqjTS"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1740672395,
    minPrice: 49
  },
  {
    id: 246,
    name: "Essential Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "essential-plan.svg",
    metadata: {
      annex: "QmdjFyochVwW8RAJm24duWKKdnmYoMHckBYSLHvnssBuR3"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1740672395,
    minPrice: 225
  },
  {
    id: 247,
    name: "Elite Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "elite-plan.svg",
    metadata: {
      annex: "QmVUZFDtszzSp48zK9Fuwu7rcbFJmWq2hTfWBBFDJhjoig"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 310
  },
  {
    id: 248,
    name: "Pendle",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "pendle.svg",
    metadata: {
      annex: "Qmd3T9SAyZaNVuCTG4DmtzpNvb1TcD5UpuHg6Aar5Fyfhp"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 249,
    name: "SparkDEX",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "sparkdex.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1733326763,
    minPrice: 100
  },
  {
    id: 250,
    name: "Fasanara",
    productType: 20,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "fasanara.svg",
    metadata: {
      annex: "QmZ8EuiNEzyvqgKDL8nqU9z3bq8m33aamd3yRobyZ1KSmE"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1747837547,
    minPrice: 100
  },
  {
    id: 251,
    name: "Term Finance",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "term-finance.png",
    metadata: {
      annex: "QmVbXfWUzskbLmZNLFTA1Epa4nJdSiH9Y1dZ7hgbvvkKw3"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1736430671,
    minPrice: 100
  },
  {
    id: 252,
    name: "Sturdy Finance",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "sturdy-finance.svg",
    metadata: {
      annex: "QmYxjsDb8cW2Dq2DfuN6rEJfZrn6ZMNGeKx5ERt1K2L8Ky"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1736430671,
    minPrice: 100
  },
  {
    id: 253,
    name: "Ethena USDe Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "ethena-usde-depeg.svg",
    metadata: {
      annex: "QmUVa9Dsm7aW6kRv5zaBf389Bw61r9gMVUYTiM6vosNiqW"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1739447471,
    minPrice: 300
  },
  {
    id: 254,
    name: "Maple",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "maple.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 100
  },
  {
    id: 255,
    name: "Syrup",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "syrup.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 100
  },
  {
    id: 256,
    name: "Uniswap v4",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "uniswap4.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 100
  },
  {
    id: 257,
    name: "Balancer v3",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "balancer-v3.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 100
  },
  {
    id: 258,
    name: "Relative Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "rfx.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1738243583,
    minPrice: 1200
  },
  {
    id: 259,
    name: "Bittensor",
    productType: 22,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "bittensor.svg",
    metadata: {
      annex: "QmRUXDPEw7vvejqqY8H5RPreqsjfJf1PCHf5qU7rTzuQcP"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1739447471,
    minPrice: 320
  },
  {
    id: 260,
    name: "DeFi Covered",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "defi-covered.svg",
    metadata: {
      annex: "QmYDPnB9Y8jp4mN5okLnyCvspu2YfMjZ3w877c7NFG3MKa"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1740672395,
    minPrice: 505
  },
  {
    id: 261,
    name: "Sky USDS Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "sky-usds-depeg.svg",
    metadata: {
      annex: "QmbNEWUyL6ZjQoQKDPDxKDYqraw6YeCjT5tQZ5RarnyRJL"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1744902863,
    minPrice: 50
  },
  {
    id: 262,
    name: "Level USD Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "lvlUSD-depeg.jpg",
    metadata: {
      annex: "QmdfQZJEStejj6ib2zJ34BePhB2haXvouNEGKUzWxGzX3Y"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 250
  },
  {
    id: 263,
    name: "Tether USDT0 Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "USDT0-depeg.svg",
    metadata: {
      annex: "QmUAFsrHFLqPoiGBDS2KqMHd9gcmadpzzoRAFqPVRXCYZu"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1745946671,
    minPrice: 50
  },
  {
    id: 264,
    name: "Resolv USR Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "USR-depeg.svg",
    metadata: {
      annex: "Qma21bqfqZ5pfVK4qa1xbHfkVMY6QDr6D5Zoe8ZYdK2g4i"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 300
  },
  {
    id: 265,
    name: "Treehouse ETH Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "tETH-depeg.svg",
    metadata: {
      annex: "QmbzSLarGctebyCWMN8UkthhY8XwsHnktuE3z3SBpX9vLA"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1739447471,
    minPrice: 125
  },
  {
    id: 266,
    name: "Super OETH Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "superoeth-depeg.svg",
    metadata: {
      annex: "QmU22xFX63uYdVDu2KSsPbo64tc7C8gefzEgkSCbGwiL6K"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 267,
    name: "WBTC Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "wbtc-depeg.svg",
    metadata: {
      annex: "QmSHHWm78wCGeJbSVz55ypn99yyPxQLqxXrxqY3Bz7DYhM"
    },
    coverAssets: [
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1739447471,
    minPrice: 50
  },
  {
    id: 268,
    name: "Ether.fi eBTC Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "eBTC-depeg.png",
    metadata: {
      annex: "QmPxHZeg5tDbVGqVbUvLikyeCjdT9PQh77akg8QBxCBVQu"
    },
    coverAssets: [
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 75
  },
  {
    id: 269,
    name: "vfat",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "vffat-depeg.png",
    metadata: {
      annex: "QmTjQTwN24mmSZMrBSVCmRNuhWn83GhRZoXsq65C5GxebU"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1745946671,
    minPrice: 100
  },
  {
    id: 270,
    name: "Entry Cover",
    productType: 19,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "entry-plan.svg",
    metadata: {
      annex: "QmWPYctRUvt65PizPdUZx9N1evtjRHTXk8dfr5EV81F7pS"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1739447471,
    minPrice: 50
  },
  {
    id: 271,
    name: "Essential Cover",
    productType: 19,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "essential-plan.svg",
    metadata: {
      annex: "QmZnqvVhssSLGmWCWac38Up2J86zAfErNygZN65pDx6djR"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1739537399,
    minPrice: 235
  },
  {
    id: 272,
    name: "Elite Cover",
    productType: 19,
    isDeprecated: true,
    useFixedPrice: true,
    logo: "elite-plan.svg",
    metadata: {
      annex: "QmeXx1D1yZhYxi2EBEErVgtzAHndi5vCfqBDds8s3WBrnp"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1739537399,
    minPrice: 380
  },
  {
    id: 273,
    name: "L1 Advisors Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "l1.svg",
    metadata: {
      annex: "QmQwwcjqp4JFErKVobsd7iv3pvgUcUNjD4DiZs3uqM9en1"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1747300211,
    minPrice: 225
  },
  {
    id: 274,
    name: "Figment ETH Slashing",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "figment-eth-slashing.svg",
    metadata: {
      annex: "QmVVZJjc498uw7Zi3Ds8H3oB2etau8icznuPNPCSeNWmcb"
    },
    coverAssets: [
      "ETH"
    ],
    isPrivate: true,
    timestamp: 1740672395,
    minPrice: 95
  },
  {
    id: 275,
    name: "PoolTogether",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "pooltogether.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1740672395,
    minPrice: 70
  },
  {
    id: 276,
    name: "Coinbase Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "coinbase.svg",
    metadata: {
      annex: "QmPniNk8eymw4EWj2mopLJxV8LcAb7ZmQGhq58D7XKxQDN"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 175
  },
  {
    id: 277,
    name: "Kraken Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "kraken.svg",
    metadata: {
      annex: "QmS924HaXh7R8nxR9EebFzBo17mKDb3deCEe3ucWkytjYy"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 175
  },
  {
    id: 278,
    name: "Binance Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "binance.svg",
    metadata: {
      annex: "QmYhQ6d3vop4fSBzrUXs4J6E9d1YMjT5XqsLPDEWKeyBeC"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 247
  },
  {
    id: 279,
    name: "OKX Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "OKX.svg",
    metadata: {
      annex: "QmZ2a66UdaGv75xF1ix7pe9WZm7ARrPjcMsXfuuwPLg4W7"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 397
  },
  {
    id: 280,
    name: "Deribit Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "deribit.jpg",
    metadata: {
      annex: "QmNdQhA4gLFADxM97oYxmrtp7hpiXzQhjmLQTx62b68G3T"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 397
  },
  {
    id: 281,
    name: "Bitmex Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "bitmex.png",
    metadata: {
      annex: "QmbyGbdUb3euTdTZVf8aZrTynEyxcZudPnKMr99L7K8tzT"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 397
  },
  {
    id: 282,
    name: "Bybit Custody",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "bybit.jpg",
    metadata: {
      annex: "QmewnLCBC9MXkMrjBTZhdgQgN6FZnzfiNtoyoZx4CegL2r"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 441
  },
  {
    id: 283,
    name: "Shadow",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "shadow.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 100
  },
  {
    id: 284,
    name: "Cork",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "cork.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 100
  },
  {
    id: 285,
    name: "Rings",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "rings.svg",
    metadata: {
      annex: "QmWqkGySFzZj2A3N8LAiVYZnViqjPbwPcCyEKd2Y3LjQGr"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1741267523,
    minPrice: 100
  },
  {
    id: 286,
    name: "Inverse DOLA Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "inverse-dola-depeg.svg",
    metadata: {
      annex: "QmbTQ18jmCTxPW257NMZd8a6V5CvZvpFzhjnoK1Eu9zVBQ"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 287,
    name: "Ensuro Yield",
    productType: 17,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "ensuro-yield.svg",
    metadata: {
      annex: "QmdtKHudPiq18i85Zrw66T7pff4mPMz637VVdNEBh3BonN"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1742481059,
    minPrice: 100
  },
  {
    id: 288,
    name: "Coinshift USDL Morpho Vault",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "coinshift-usdl-morpho-vault.svg",
    metadata: {
      annex: "QmRi8M9T96fm2QJT6X453Ef2RAbx8prYGzSuSYmvXVjTeS"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 185
  },
  {
    id: 289,
    name: "B-Tier Morpho Vaults",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "b-tier-morpho-vaults.svg",
    metadata: {
      annex: "QmfHukq2kAgdkq7sU6CtVn86cVsXdmfCgeYK6kJQuxNqDv"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 290,
    name: "B-Tier Euler v2 Markets",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "b-tier-euler-v2-markets.svg",
    metadata: {
      annex: "QmZHbpDkVpkaMHf7yFAUGqM1Vsui6YeGZbubTCGuMPtZPu"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1743519947,
    minPrice: 100
  },
  {
    id: 291,
    name: "OC Cover",
    productType: 20,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "oc-cover.svg",
    metadata: {
      annex: "QmbV3w2FHwnR8opvvFewMr7boYReT3ViL49QZvjyeDQyrj"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: true,
    timestamp: 1743519947,
    minPrice: 100
  },
  {
    id: 292,
    name: "Usual Bug Bounty",
    productType: 15,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "usual-bug-bounty.svg",
    metadata: {
      annex: "QmTtaR6AP5zpyDiY9eEsxf7uBStz4K5FaAap4ssKH4b6Vd"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: true,
    timestamp: 1743670835,
    minPrice: 1586
  },
  {
    id: 293,
    name: "Resupply USD (reUSD) Depeg",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "reusd.svg",
    metadata: {
      annex: "QmVqEUhX3Jja82R946HT1gKwGrkH1WMqHU1ajuwUbCQHy2"
    },
    coverAssets: [
      "USDC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 275
  },
  {
    id: 294,
    name: "Origin Sonic (OS)",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "origin.jpg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1744110779,
    minPrice: 100
  },
  {
    id: 295,
    name: "Byzantine Finance",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "byzantine-finance.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1744902863,
    minPrice: 100
  },
  {
    id: 296,
    name: "Brava Conservative Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "brava-conservative-cover.svg",
    metadata: {
      annex: "QmRLCbNvM2qq7mgPfwTgweXb7frekytaGsFWLSqf9T657p"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1744902863,
    minPrice: 17
  },
  {
    id: 297,
    name: "Brava Balanced Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "brava-balanced-cover.svg",
    metadata: {
      annex: "QmdTY8hSaqqNiZrzo47UyLDVJMcKkuxwi53k6hiXqcVG4U"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1744902863,
    minPrice: 195
  },
  {
    id: 298,
    name: "Brava Advanced Cover",
    productType: 19,
    isDeprecated: false,
    useFixedPrice: true,
    logo: "brava-advanced-cover.svg",
    metadata: {
      annex: "QmVFSXcyS7cfFDsmrJFHwhs9VdDE1jdwAFVaEaEdhuy4B1"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 309
  },
  {
    id: 299,
    name: "Extrafi Xlend",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "extrafi-xlend.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1745946671,
    minPrice: 100
  },
  {
    id: 300,
    name: "Ambient Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "ambient-finance.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1745946671,
    minPrice: 100
  },
  {
    id: 301,
    name: "Kinetic",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "kinetic.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 302,
    name: "Revert Finance",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "revert-finance.png",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747055891,
    minPrice: 100
  },
  {
    id: 303,
    name: "WBTC / eUSD Morpho Market",
    productType: 21,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "wbtc-eusd-morpho-market.svg",
    metadata: {
      annex: "QmbKJVbD5EkMwd3n6SYkvAcjSArcpTtdjfKNCJiX2K2ES4"
    },
    coverAssets: [
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747300211,
    minPrice: 100
  },
  {
    id: 304,
    name: "Stackup",
    productType: 0,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "stackup.svg",
    metadata: {},
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1747300211,
    minPrice: 50
  },
  {
    id: 305,
    name: "YO",
    productType: 11,
    isDeprecated: false,
    useFixedPrice: false,
    logo: "yo-protocol.png",
    metadata: {
      annex: "QmVgCzt7hntgdju37yxwLrSdBERRXV2TiNJgD6bhSno5F7"
    },
    coverAssets: [
      "ETH",
      "USDC",
      "cbBTC"
    ],
    isPrivate: false,
    timestamp: 1748970347,
    minPrice: 350
  }
];

// src/quote/getQuoteAndBuyCoverInputs.ts
var productsMap = products_default.reduce(
  (acc, product) => ({ ...acc, [product.id]: product }),
  {}
);
async function getQuoteAndBuyCoverInputs(productId, coverAmount, coverPeriod, coverAsset, coverBuyerAddress, slippage = DEFAULT_SLIPPAGE / SLIPPAGE_DENOMINATOR, ipfsCidOrContent = "", nexusApiUrl = "https://api.nexusmutual.io/v2", commissionRatio, commissionDestination, paymentAsset = coverAsset) {
  if (!Number.isInteger(productId) || productId <= 0) {
    return { result: void 0, error: { message: "Invalid productId: must be a positive integer" } };
  }
  if (typeof coverAmount !== "string" || !/^\d+$/.test(coverAmount) || parseInt(coverAmount, 10) <= 0) {
    return { result: void 0, error: { message: "Invalid coverAmount: must be a positive integer string" } };
  }
  if (!Number.isInteger(coverPeriod) || coverPeriod < MINIMUM_COVER_PERIOD || coverPeriod > MAXIMUM_COVER_PERIOD) {
    return {
      result: void 0,
      error: {
        message: `Invalid coverPeriod: must be between ${MINIMUM_COVER_PERIOD} and ${MAXIMUM_COVER_PERIOD} days`
      }
    };
  }
  const coverAssetsString = Object.keys(CoverAsset).filter((k) => isNaN(+k)).map((k) => `CoverAsset.${k}`).join(", ");
  if (!Object.values(CoverAsset).includes(coverAsset)) {
    return {
      result: void 0,
      error: { message: `Invalid coverAsset: must be one of ${coverAssetsString}` }
    };
  }
  if (paymentAsset !== 255 /* NXM */ && paymentAsset !== coverAsset) {
    return {
      result: void 0,
      error: { message: `Invalid payment asset: must be one of ${coverAsset} or NXM` }
    };
  }
  if (!/^0x[a-fA-F0-9]{40}$/.test(coverBuyerAddress)) {
    return { result: void 0, error: { message: "Invalid coverBuyerAddress: must be a valid Ethereum address" } };
  }
  if (typeof slippage !== "number" || slippage < 0 || slippage > 1) {
    return {
      result: void 0,
      error: { message: "Invalid slippage: must be a number between 0 and 1" }
    };
  }
  if (typeof ipfsCidOrContent !== "string" && !ipfsCidOrContent?.version) {
    return { result: void 0, error: { message: "Invalid ipfsCid: must be a valid IPFS CID" } };
  }
  if (typeof ipfsCidOrContent === "string" && ipfsCidOrContent !== "") {
    const isValidCID = validateIPFSCid(ipfsCidOrContent);
    if (!isValidCID) {
      return {
        result: void 0,
        error: { message: "Invalid ipfsCid: must be a valid IPFS CID" }
      };
    }
  }
  const productType = productsMap[productId]?.productType;
  if (productType === void 0) {
    return {
      result: void 0,
      error: { message: `Invalid product` }
    };
  }
  if (IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE[productType] !== void 0 && !ipfsCidOrContent) {
    return {
      result: void 0,
      error: {
        message: `Missing IPFS content. 

        ${product_types_default[productType]?.name} requires ${IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE[productType]} content type.`
      }
    };
  }
  let ipfsData = ipfsCidOrContent;
  const contentType = IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE[productType];
  if (typeof ipfsCidOrContent !== "string" && contentType !== void 0 && ipfsCidOrContent) {
    try {
      ipfsData = await uploadIPFSContent([contentType, ipfsCidOrContent], nexusApiUrl);
    } catch (error) {
      return {
        result: void 0,
        error: { message: error.message || "Failed to upload IPFS content" }
      };
    }
  }
  slippage = slippage * SLIPPAGE_DENOMINATOR;
  try {
    const { quote } = await getQuote(
      productId,
      coverAmount,
      coverPeriod,
      coverAsset,
      nexusApiUrl,
      paymentAsset
    );
    const maxPremiumInAsset = calculatePremiumWithCommissionAndSlippage(
      BigInt(quote.premiumInAsset),
      commissionRatio || BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE[productType],
      slippage
    );
    const yearlyCostPerc = calculatePremiumWithCommissionAndSlippage(
      BigInt(quote.annualPrice),
      commissionRatio || BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE[productType],
      slippage
    );
    const result = {
      displayInfo: {
        premiumInAsset: maxPremiumInAsset.toString(),
        coverAmount,
        yearlyCostPerc: Number(yearlyCostPerc) / TARGET_PRICE_DENOMINATOR,
        maxCapacity: await getProductCapacity(productId, coverPeriod, coverAsset, nexusApiUrl) ?? ""
      },
      buyCoverInput: {
        buyCoverParams: {
          coverId: 0 /* BUY */,
          owner: coverBuyerAddress,
          productId,
          coverAsset,
          amount: coverAmount,
          period: coverPeriod * 60 * 60 * 24,
          // seconds
          maxPremiumInAsset: maxPremiumInAsset.toString(),
          paymentAsset: coverAsset,
          commissionRatio: commissionRatio || BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE[productType],
          commissionDestination: commissionDestination || BUY_COVER_COMMISSION_DESTINATION_BY_PRODUCT_TYPE[productType],
          ipfsData
        },
        poolAllocationRequests: quote.poolAllocationRequests
      }
    };
    return { result, error: void 0 };
  } catch (error) {
    const errorResponse = await handleError(error, productId, coverPeriod, coverAsset, nexusApiUrl);
    return errorResponse;
  }
}
async function getQuote(productId, coverAmount, coverPeriod, coverAsset, nexusApiUrl, paymentAsset) {
  const params = {
    productId,
    amount: coverAmount,
    period: coverPeriod,
    coverAsset,
    paymentAsset
  };
  const response = await axios2.get(nexusApiUrl + "/quote", { params });
  if (!response.data) {
    throw new Error("Failed to fetch cover quote");
  }
  return response.data;
}
async function getProductCapacity(productId, coverPeriod, coverAsset, nexusApiUrl) {
  const params = { period: coverPeriod };
  const capacityUrl = nexusApiUrl + `/capacity/${productId}`;
  const response = await axios2.get(capacityUrl, { params });
  if (!response.data) {
    throw new Error("Failed to fetch cover capacities");
  }
  return response.data.availableCapacity.find((av) => av.assetId === coverAsset)?.amount;
}
async function handleError(error, productId, coverPeriod, coverAsset, nexusApiUrl) {
  const axiosError = error;
  if (axiosError.isAxiosError) {
    if (axiosError.response?.data?.error?.includes("Not enough capacity")) {
      const maxCapacity = await getProductCapacity(productId, coverPeriod, coverAsset, nexusApiUrl);
      return {
        result: void 0,
        error: {
          message: axiosError.response?.data.error,
          data: maxCapacity ? { maxCapacity } : void 0
        }
      };
    }
  }
  return {
    result: void 0,
    error: { message: error.message || "Something went wrong" }
  };
}

// src/swap/index.ts
var swap_exports = {};
__export(swap_exports, {
  calculateEthForExactNxm: () => calculateEthForExactNxm,
  calculateExactEthForNxm: () => calculateExactEthForNxm,
  calculateExactNxmForEth: () => calculateExactNxmForEth,
  calculateNxmForExactEth: () => calculateNxmForExactEth,
  calculatePriceImpactA: () => calculatePriceImpactA,
  calculatePriceImpactB: () => calculatePriceImpactB,
  calculateSpotPrice: () => calculateSpotPrice
});

// src/swap/calculateExactNxmForEth.ts
var calculateExactNxmForEth = (ethIn, reserves) => {
  if (ethIn <= 0n) {
    throw new Error("ETH in value must be greater than 0");
  }
  const k = reserves.nxmA * reserves.ethReserve;
  const ethReservesAfter = reserves.ethReserve + ethIn;
  const nxmReservesAfter = k / ethReservesAfter;
  const nxmOut = reserves.nxmA - nxmReservesAfter;
  if (nxmOut < 0n) {
    throw new Error("Cannot swap this amount");
  }
  return nxmOut;
};

// src/swap/calculateExactEthForNxm.ts
var calculateExactEthForNxm = (nxmIn, reserves) => {
  if (nxmIn <= 0n) {
    throw new Error("NXM in value must be greater than 0");
  }
  const k = reserves.nxmB * reserves.ethReserve;
  const nxmReservesAfter = reserves.nxmB + nxmIn;
  const ethReservesAfter = k / nxmReservesAfter;
  const ethOut = reserves.ethReserve - ethReservesAfter;
  if (ethOut < 0n) {
    throw new Error("Cannot swap this amount");
  }
  return ethOut;
};

// src/swap/calculateNxmForExactEth.ts
var calculateNxmForExactEth = (ethOut, reserves) => {
  if (ethOut <= 0n || ethOut >= reserves.ethReserve) {
    throw new Error("ETH out value must be greater than 0 and less than the reserves");
  }
  const k = reserves.nxmB * reserves.ethReserve;
  const ethReservesAfter = reserves.ethReserve - ethOut;
  const nxmReservesAfter = k / ethReservesAfter;
  const nxmIn = nxmReservesAfter - reserves.nxmB;
  return nxmIn;
};

// src/swap/calculateEthForExactNxm.ts
var calculateEthForExactNxm = (nxmOut, reserves) => {
  if (nxmOut <= 0n || nxmOut >= reserves.nxmA) {
    throw new Error("NXM out value must be greater than 0 and less than the reserves");
  }
  const k = reserves.nxmA * reserves.ethReserve;
  const nxmReservesAfter = reserves.nxmA - nxmOut;
  const ethReservesAfter = k / nxmReservesAfter;
  const ethIn = ethReservesAfter - reserves.ethReserve;
  return ethIn;
};

// src/swap/calculateSpotPrice.ts
var calculateSpotPrice = (reserves) => {
  const oneEth = BigInt(1e18);
  return {
    spotPriceA: oneEth * reserves.ethReserve / reserves.nxmA,
    spotPriceB: oneEth * reserves.ethReserve / reserves.nxmB
  };
};

// src/swap/calculatePriceImpactA.ts
var calculatePriceImpactA = (ethIn, reserves) => {
  const { spotPriceA } = calculateSpotPrice(reserves);
  const nxmOut = calculateExactNxmForEth(ethIn, reserves);
  const nxmOutAtSpotPrice = BigInt(1e18) * ethIn / spotPriceA;
  return BigInt(1e6) - BigInt(1e6) * nxmOut / nxmOutAtSpotPrice;
};

// src/swap/calculatePriceImpactB.ts
var calculatePriceImpactB = (nxmIn, reserves) => {
  const { spotPriceB } = calculateSpotPrice(reserves);
  const ethOut = calculateExactEthForNxm(nxmIn, reserves);
  const ethOutAtSpotPrice = spotPriceB * nxmIn / BigInt(1e18);
  return BigInt(1e6) - BigInt(1e6) * ethOut / ethOutAtSpotPrice;
};

// src/types/index.ts
var types_exports2 = {};
__export(types_exports2, {
  ContentType: () => ContentType,
  IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE: () => IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE
});

// src/index.ts
export * from "@nexusmutual/deployments";
var nexusSdk = {
  ...deployments,
  products: products_default,
  productTypes: product_types_default,
  ...types_exports,
  ...swap_exports,
  ...buyCover_exports,
  ...types_exports2,
  ...quote_exports,
  ...ipfs_exports,
  ...constants_exports
};
var src_default = nexusSdk;
export {
  BUY_COVER_COMMISSION_DESTINATION_BY_PRODUCT_TYPE,
  BUY_COVER_COMMISSION_RATIO_BY_PRODUCT_TYPE,
  COMMISSION_DENOMINATOR,
  CRYPTO_COVER_COMMISSION_RATIO,
  ContentType,
  CoverAsset,
  CoverId,
  DEFAULT_COMMISSION_RATIO,
  DEFAULT_SLIPPAGE,
  DEFI_PASS_COMMISSION_RATIO,
  FUND_PORTFOLIO_COMMISSION_RATIO,
  GENERALISED_FUND_PORTFOLIO_COMMISSION_RATIO,
  IMMUNEFI_ADDRESS,
  IPFS_CONTENT_TYPE_BY_PRODUCT_TYPE,
  MAXIMUM_COVER_PERIOD,
  MINIMUM_COVER_PERIOD,
  NEXUS_MUTUAL_COVER_COMMISSION_RATIO,
  NEXUS_MUTUAL_DAO_TREASURY_ADDRESS,
  NO_COMMISSION,
  NO_COMMISSION_DESTINATION,
  PaymentAsset,
  ProductCategoryEnum,
  ProductTypes,
  SHERLOCK_BUG_BOUNTY_COMMISSION_RATIO,
  SLIPPAGE_DENOMINATOR,
  SPEARBIT_CANTINA_ADDRESS,
  TARGET_PRICE_DENOMINATOR,
  TRM_COMMISSION_RATIO,
  UNITY_ADDRESS,
  allLogoFileNames,
  allLogoNames,
  allPrivateProductsIds,
  calculateEthForExactNxm,
  calculateExactEthForNxm,
  calculateExactNxmForEth,
  calculateNxmForExactEth,
  calculatePremiumWithCommissionAndSlippage,
  calculatePriceImpactA,
  calculatePriceImpactB,
  calculateSpotPrice,
  categoryLabelByEnum,
  src_default as default,
  getQuoteAndBuyCoverInputs,
  productCategoryMap,
  product_types_default as productTypes,
  products_default as products,
  productsMap,
  uploadIPFSContent,
  validateIPFSCid,
  validateIPFSContent
};
//# sourceMappingURL=index.mjs.map